/** Checks if value is string */ function $b9f82b1f38a24931$export$844ec244b1367d54(str) {
    return typeof str === "string" || str instanceof String;
}
/** Checks if value is object */ function $b9f82b1f38a24931$export$a6cdc56e425d0d0a(obj) {
    var _obj$constructor;
    return typeof obj === "object" && obj != null && (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === "Object";
}
function $b9f82b1f38a24931$export$357523c63a2253b9(obj, keys) {
    if (Array.isArray(keys)) return $b9f82b1f38a24931$export$357523c63a2253b9(obj, (_, k)=>keys.includes(k));
    return Object.entries(obj).reduce((acc, _ref)=>{
        let [k, v] = _ref;
        if (keys(v, k)) acc[k] = v;
        return acc;
    }, {});
}
/** Direction */ const $b9f82b1f38a24931$export$9106728c49045482 = {
    NONE: "NONE",
    LEFT: "LEFT",
    FORCE_LEFT: "FORCE_LEFT",
    RIGHT: "RIGHT",
    FORCE_RIGHT: "FORCE_RIGHT"
};
/** Direction */ function $b9f82b1f38a24931$export$32af4dafed14c8ce(direction) {
    switch(direction){
        case $b9f82b1f38a24931$export$9106728c49045482.LEFT:
            return $b9f82b1f38a24931$export$9106728c49045482.FORCE_LEFT;
        case $b9f82b1f38a24931$export$9106728c49045482.RIGHT:
            return $b9f82b1f38a24931$export$9106728c49045482.FORCE_RIGHT;
        default:
            return direction;
    }
}
/** Escapes regular expression control chars */ function $b9f82b1f38a24931$export$7c57da42ce8e346f(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function $b9f82b1f38a24931$export$7aeb68f71172641d(b, a) {
    if (a === b) return true;
    const arrA = Array.isArray(a), arrB = Array.isArray(b);
    let i;
    if (arrA && arrB) {
        if (a.length != b.length) return false;
        for(i = 0; i < a.length; i++)if (!$b9f82b1f38a24931$export$7aeb68f71172641d(a[i], b[i])) return false;
        return true;
    }
    if (arrA != arrB) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        const dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA && dateB) return a.getTime() == b.getTime();
        if (dateA != dateB) return false;
        const regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA && regexpB) return a.toString() == b.toString();
        if (regexpA != regexpB) return false;
        const keys = Object.keys(a);
        // if (keys.length !== Object.keys(b).length) return false;
        for(i = 0; i < keys.length; i++)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = 0; i < keys.length; i++)if (!$b9f82b1f38a24931$export$7aeb68f71172641d(b[keys[i]], a[keys[i]])) return false;
        return true;
    } else if (a && b && typeof a === "function" && typeof b === "function") return a.toString() === b.toString();
    return false;
}



/** Provides details of changing input */ class $6d3a752202397b67$export$2e2bcd8739ae039 {
    /** Current input value */ /** Current cursor position */ /** Old input value */ /** Old selection */ constructor(opts){
        Object.assign(this, opts);
        // double check if left part was changed (autofilling, other non-standard input triggers)
        while(this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos))--this.oldSelection.start;
    }
    /** Start changing position */ get startChangePos() {
        return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /** Inserted symbols count */ get insertedCount() {
        return this.cursorPos - this.startChangePos;
    }
    /** Inserted symbols */ get inserted() {
        return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /** Removed symbols count */ get removedCount() {
        // Math.max for opposite operation
        return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
        this.oldValue.length - this.value.length, 0);
    }
    /** Removed symbols */ get removed() {
        return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /** Unchanged head symbols */ get head() {
        return this.value.substring(0, this.startChangePos);
    }
    /** Unchanged tail symbols */ get tail() {
        return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /** Remove direction */ get removeDirection() {
        if (!this.removedCount || this.insertedCount) return (0, $b9f82b1f38a24931$export$9106728c49045482).NONE;
        // align right if delete at right
        return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
        this.oldSelection.end === this.oldSelection.start ? (0, $b9f82b1f38a24931$export$9106728c49045482).RIGHT : (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT;
    }
}



/** Applies mask on element */ function $7f8f9e4cb1731024$export$2e2bcd8739ae039(el, opts) {
    // currently available only for input-like elements
    return new $7f8f9e4cb1731024$export$2e2bcd8739ae039.InputMask(el, opts);
}


// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// export function maskedClass(mask: string): typeof MaskedPattern;
// export function maskedClass(mask: DateConstructor): typeof MaskedDate;
// export function maskedClass(mask: NumberConstructor): typeof MaskedNumber;
// export function maskedClass(mask: Array<any> | ArrayConstructor): typeof MaskedDynamic;
// export function maskedClass(mask: MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass(mask: Masked): typeof Masked;
// export function maskedClass(mask: typeof Masked): typeof Masked;
// export function maskedClass(mask: typeof MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: typeof MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: typeof MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: typeof MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: typeof MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: typeof MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: typeof MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: typeof MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass<Mask extends typeof Masked> (mask: Mask): Mask;
// export function maskedClass(mask: RegExp): typeof MaskedRegExp;
// export function maskedClass(mask: (value: string, ...args: any[]) => boolean): typeof MaskedFunction;
/** Get Masked class by mask type */ function $9b2a7934382d129f$export$81ad4b1539a22420(mask) /* TODO */ {
    if (mask == null) throw new Error("mask property should be defined");
    if (mask instanceof RegExp) return (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedRegExp;
    if ((0, $b9f82b1f38a24931$export$844ec244b1367d54)(mask)) return (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedPattern;
    if (mask === Date) return (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedDate;
    if (mask === Number) return (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedNumber;
    if (Array.isArray(mask) || mask === Array) return (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedDynamic;
    if ((0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked && mask.prototype instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked) return mask;
    if ((0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked && mask instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked) return mask.constructor;
    if (mask instanceof Function) return (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedFunction;
    console.warn("Mask not found for mask", mask); // eslint-disable-line no-console
    return (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked;
}
function $9b2a7934382d129f$export$a213ae1c699d7230(opts) {
    if (!opts) throw new Error("Options in not defined");
    if ((0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked) {
        if (opts.prototype instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked) return {
            mask: opts
        };
        /*
      handle cases like:
      1) opts = Masked
      2) opts = { mask: Masked, ...instanceOpts }
    */ const { mask: mask, ...instanceOpts } = opts instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked ? {
            mask: opts
        } : (0, $b9f82b1f38a24931$export$a6cdc56e425d0d0a)(opts) && opts.mask instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked ? opts : {};
        if (mask) {
            const _mask = mask.mask;
            return {
                ...(0, $b9f82b1f38a24931$export$357523c63a2253b9)(mask, (_, k)=>!k.startsWith("_")),
                mask: mask.constructor,
                _mask: _mask,
                ...instanceOpts
            };
        }
    }
    if (!(0, $b9f82b1f38a24931$export$a6cdc56e425d0d0a)(opts)) return {
        mask: opts
    };
    return {
        ...opts
    };
}
// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// From masked
// export default function createMask<Opts extends Masked, ReturnMasked=Opts> (opts: Opts): ReturnMasked;
// // From masked class
// export default function createMask<Opts extends MaskedOptions<typeof Masked>, ReturnMasked extends Masked=InstanceType<Opts['mask']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDate>, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedNumber>, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedEnum>, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRange>, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedFunction>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedPattern>, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDynamic>, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// // From mask opts
// export default function createMask<Opts extends MaskedOptions<Masked>, ReturnMasked=Opts extends MaskedOptions<infer M> ? M : never> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedNumberOptions, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDateFactoryOptions, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedEnumOptions, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedRangeOptions, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedPatternOptions, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDynamicOptions, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<RegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<Function>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
/** Creates new {@link Masked} depending on mask type */ function $9b2a7934382d129f$export$2e2bcd8739ae039(opts) {
    if ((0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked && opts instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked) return opts;
    const nOpts = $9b2a7934382d129f$export$a213ae1c699d7230(opts);
    const MaskedClass = $9b2a7934382d129f$export$81ad4b1539a22420(nOpts.mask);
    if (!MaskedClass) throw new Error("Masked class is not found for provided mask, appropriate module needs to be imported manually before creating mask.");
    if (nOpts.mask === MaskedClass) delete nOpts.mask;
    if (nOpts._mask) {
        nOpts.mask = nOpts._mask;
        delete nOpts._mask;
    }
    return new MaskedClass(nOpts);
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).createMask = $9b2a7934382d129f$export$2e2bcd8739ae039;



/**  Generic element API to use with mask */ class $600250ccf0419caa$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** Safely returns selection start */ get selectionStart() {
        let start;
        try {
            start = this._unsafeSelectionStart;
        } catch  {}
        return start != null ? start : this.value.length;
    }
    /** Safely returns selection end */ get selectionEnd() {
        let end;
        try {
            end = this._unsafeSelectionEnd;
        } catch  {}
        return end != null ? end : this.value.length;
    }
    /** Safely sets element selection */ select(start, end) {
        if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
        try {
            this._unsafeSelect(start, end);
        } catch  {}
    }
    /** */ get isActive() {
        return false;
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskElement = $600250ccf0419caa$export$2e2bcd8739ae039;




/** Bridge between HTMLElement and {@link Masked} */ class $910b09fe2b01933a$export$2e2bcd8739ae039 extends (0, $600250ccf0419caa$export$2e2bcd8739ae039) {
    /** HTMLElement to use mask on */ constructor(input){
        super();
        this.input = input;
        this._handlers = {};
    }
    get rootElement() {
        var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
        return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
    }
    /**
    Is element in focus
  */ get isActive() {
        return this.input === this.rootElement.activeElement;
    }
    /**
    Binds HTMLElement events to mask internal events
  */ bindEvents(handlers) {
        Object.keys(handlers).forEach((event)=>this._toggleEventHandler($910b09fe2b01933a$export$2e2bcd8739ae039.EVENTS_MAP[event], handlers[event]));
    }
    /**
    Unbinds HTMLElement events to mask internal events
  */ unbindEvents() {
        Object.keys(this._handlers).forEach((event)=>this._toggleEventHandler(event));
    }
    _toggleEventHandler(event, handler) {
        if (this._handlers[event]) {
            this.input.removeEventListener(event, this._handlers[event]);
            delete this._handlers[event];
        }
        if (handler) {
            this.input.addEventListener(event, handler);
            this._handlers[event] = handler;
        }
    }
}
/** Mapping between HTMLElement events and mask internal events */ $910b09fe2b01933a$export$2e2bcd8739ae039.EVENTS_MAP = {
    selectionChange: "keydown",
    input: "input",
    drop: "drop",
    click: "click",
    focus: "focus",
    commit: "blur"
};
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).HTMLMaskElement = $910b09fe2b01933a$export$2e2bcd8739ae039;




/** Bridge between InputElement and {@link Masked} */ class $26232c39b47ea1e1$export$2e2bcd8739ae039 extends (0, $910b09fe2b01933a$export$2e2bcd8739ae039) {
    /** InputElement to use mask on */ constructor(input){
        super(input);
        this.input = input;
        this._handlers = {};
    }
    /** Returns InputElement selection start */ get _unsafeSelectionStart() {
        return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }
    /** Returns InputElement selection end */ get _unsafeSelectionEnd() {
        return this.input.selectionEnd;
    }
    /** Sets InputElement selection */ _unsafeSelect(start, end) {
        this.input.setSelectionRange(start, end);
    }
    get value() {
        return this.input.value;
    }
    set value(value) {
        this.input.value = value;
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).HTMLMaskElement = (0, $910b09fe2b01933a$export$2e2bcd8739ae039);





class $1102251dbd92a30c$export$2e2bcd8739ae039 extends (0, $910b09fe2b01933a$export$2e2bcd8739ae039) {
    /** Returns HTMLElement selection start */ get _unsafeSelectionStart() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Returns HTMLElement selection end */ get _unsafeSelectionEnd() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Sets HTMLElement selection */ _unsafeSelect(start, end) {
        if (!this.rootElement.createRange) return;
        const range = this.rootElement.createRange();
        range.setStart(this.input.firstChild || this.input, start);
        range.setEnd(this.input.lastChild || this.input, end);
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    /** HTMLElement value */ get value() {
        return this.input.textContent || "";
    }
    set value(value) {
        this.input.textContent = value;
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).HTMLContenteditableMaskElement = $1102251dbd92a30c$export$2e2bcd8739ae039;




/** Listens to element events and controls changes between element and {@link Masked} */ class $d7dde2aa418edea9$export$2e2bcd8739ae039 {
    /**
    View element
  */ /** Internal {@link Masked} model */ constructor(el, opts){
        this.el = el instanceof (0, $600250ccf0419caa$export$2e2bcd8739ae039) ? el : el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA" ? new (0, $1102251dbd92a30c$export$2e2bcd8739ae039)(el) : new (0, $26232c39b47ea1e1$export$2e2bcd8739ae039)(el);
        this.masked = (0, $9b2a7934382d129f$export$2e2bcd8739ae039)(opts);
        this._listeners = {};
        this._value = "";
        this._unmaskedValue = "";
        this._saveSelection = this._saveSelection.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onClick = this._onClick.bind(this);
        this.alignCursor = this.alignCursor.bind(this);
        this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
        this._bindEvents();
        // refresh
        this.updateValue();
        this._onChange();
    }
    maskEquals(mask) {
        var _this$masked;
        return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
    }
    /** Masked */ get mask() {
        return this.masked.mask;
    }
    set mask(mask) {
        if (this.maskEquals(mask)) return;
        if (!(mask instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked) && this.masked.constructor === (0, $9b2a7934382d129f$export$81ad4b1539a22420)(mask)) {
            // TODO "any" no idea
            this.masked.updateOptions({
                mask: mask
            });
            return;
        }
        const masked = mask instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked ? mask : (0, $9b2a7934382d129f$export$2e2bcd8739ae039)({
            mask: mask
        });
        masked.unmaskedValue = this.masked.unmaskedValue;
        this.masked = masked;
    }
    /** Raw value */ get value() {
        return this._value;
    }
    set value(str) {
        if (this.value === str) return;
        this.masked.value = str;
        this.updateControl();
        this.alignCursor();
    }
    /** Unmasked value */ get unmaskedValue() {
        return this._unmaskedValue;
    }
    set unmaskedValue(str) {
        if (this.unmaskedValue === str) return;
        this.masked.unmaskedValue = str;
        this.updateControl();
        this.alignCursor();
    }
    /** Typed unmasked value */ get typedValue() {
        return this.masked.typedValue;
    }
    set typedValue(val) {
        if (this.masked.typedValueEquals(val)) return;
        this.masked.typedValue = val;
        this.updateControl();
        this.alignCursor();
    }
    /** Display value */ get displayValue() {
        return this.masked.displayValue;
    }
    /** Starts listening to element events */ _bindEvents() {
        this.el.bindEvents({
            selectionChange: this._saveSelection,
            input: this._onInput,
            drop: this._onDrop,
            click: this._onClick,
            focus: this._onFocus,
            commit: this._onChange
        });
    }
    /** Stops listening to element events */ _unbindEvents() {
        if (this.el) this.el.unbindEvents();
    }
    /** Fires custom event */ _fireEvent(ev, e) {
        const listeners = this._listeners[ev];
        if (!listeners) return;
        listeners.forEach((l)=>l(e));
    }
    /** Current selection start */ get selectionStart() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */ get cursorPos() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    }
    set cursorPos(pos) {
        if (!this.el || !this.el.isActive) return;
        this.el.select(pos, pos);
        this._saveSelection();
    }
    /** Stores current selection */ _saveSelection() {
        if (this.displayValue !== this.el.value) console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."); // eslint-disable-line no-console
        this._selection = {
            start: this.selectionStart,
            end: this.cursorPos
        };
    }
    /** Syncronizes model value from view */ updateValue() {
        this.masked.value = this.el.value;
        this._value = this.masked.value;
    }
    /** Syncronizes view from model value, fires change events */ updateControl() {
        const newUnmaskedValue = this.masked.unmaskedValue;
        const newValue = this.masked.value;
        const newDisplayValue = this.displayValue;
        const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
        this._unmaskedValue = newUnmaskedValue;
        this._value = newValue;
        if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
        if (isChanged) this._fireChangeEvents();
    }
    /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */ updateOptions(opts) {
        const { mask: mask, ...restOpts } = opts;
        const updateMask = !this.maskEquals(mask);
        const updateOpts = !(0, $b9f82b1f38a24931$export$7aeb68f71172641d)(this.masked, restOpts);
        if (updateMask) this.mask = mask;
        if (updateOpts) this.masked.updateOptions(restOpts); // TODO
        if (updateMask || updateOpts) this.updateControl();
    }
    /** Updates cursor */ updateCursor(cursorPos) {
        if (cursorPos == null) return;
        this.cursorPos = cursorPos;
        // also queue change cursor for mobile browsers
        this._delayUpdateCursor(cursorPos);
    }
    /** Delays cursor update to support mobile browsers */ _delayUpdateCursor(cursorPos) {
        this._abortUpdateCursor();
        this._changingCursorPos = cursorPos;
        this._cursorChanging = setTimeout(()=>{
            if (!this.el) return; // if was destroyed
            this.cursorPos = this._changingCursorPos;
            this._abortUpdateCursor();
        }, 10);
    }
    /** Fires custom events */ _fireChangeEvents() {
        this._fireEvent("accept", this._inputEvent);
        if (this.masked.isComplete) this._fireEvent("complete", this._inputEvent);
    }
    /** Aborts delayed cursor update */ _abortUpdateCursor() {
        if (this._cursorChanging) {
            clearTimeout(this._cursorChanging);
            delete this._cursorChanging;
        }
    }
    /** Aligns cursor to nearest available position */ alignCursor() {
        this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT));
    }
    /** Aligns cursor only if selection is empty */ alignCursorFriendly() {
        if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
        this.alignCursor();
    }
    /** Adds listener on custom event */ on(ev, handler) {
        if (!this._listeners[ev]) this._listeners[ev] = [];
        this._listeners[ev].push(handler);
        return this;
    }
    /** Removes custom event listener */ off(ev, handler) {
        if (!this._listeners[ev]) return this;
        if (!handler) {
            delete this._listeners[ev];
            return this;
        }
        const hIndex = this._listeners[ev].indexOf(handler);
        if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
        return this;
    }
    /** Handles view input event */ _onInput(e) {
        this._inputEvent = e;
        this._abortUpdateCursor();
        // fix strange IE behavior
        if (!this._selection) return this.updateValue();
        const details = new (0, $6d3a752202397b67$export$2e2bcd8739ae039)({
            // new state
            value: this.el.value,
            cursorPos: this.cursorPos,
            // old state
            oldValue: this.displayValue,
            oldSelection: this._selection
        });
        const oldRawValue = this.masked.rawInputValue;
        const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
            input: true,
            raw: true
        }).offset;
        // force align in remove direction only if no input chars were removed
        // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
        const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : (0, $b9f82b1f38a24931$export$9106728c49045482).NONE;
        let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
        if (removeDirection !== (0, $b9f82b1f38a24931$export$9106728c49045482).NONE) cursorPos = this.masked.nearestInputPos(cursorPos, (0, $b9f82b1f38a24931$export$9106728c49045482).NONE);
        this.updateControl();
        this.updateCursor(cursorPos);
        delete this._inputEvent;
    }
    /** Handles view change event and commits model value */ _onChange() {
        if (this.displayValue !== this.el.value) this.updateValue();
        this.masked.doCommit();
        this.updateControl();
        this._saveSelection();
    }
    /** Handles view drop event, prevents by default */ _onDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }
    /** Restore last selection on focus */ _onFocus(ev) {
        this.alignCursorFriendly();
    }
    /** Restore last selection on focus */ _onClick(ev) {
        this.alignCursorFriendly();
    }
    /** Unbind view events and removes element reference */ destroy() {
        this._unbindEvents();
        this._listeners.length = 0;
        delete this.el;
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).InputMask = $d7dde2aa418edea9$export$2e2bcd8739ae039;








/** Provides details of changing model value */ class $bd3b02e030d373d5$export$2e2bcd8739ae039 {
    /** Inserted symbols */ /** Can skip chars */ /** Additional offset if any changes occurred before tail */ /** Raw inserted is used by dynamic mask */ static normalize(prep) {
        return Array.isArray(prep) ? prep : [
            prep,
            new $bd3b02e030d373d5$export$2e2bcd8739ae039()
        ];
    }
    constructor(details){
        Object.assign(this, {
            inserted: "",
            rawInserted: "",
            skip: false,
            tailShift: 0
        }, details);
    }
    /** Aggregate changes */ aggregate(details) {
        this.rawInserted += details.rawInserted;
        this.skip = this.skip || details.skip;
        this.inserted += details.inserted;
        this.tailShift += details.tailShift;
        return this;
    }
    /** Total offset considering all changes */ get offset() {
        return this.tailShift + this.inserted.length;
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).ChangeDetails = $bd3b02e030d373d5$export$2e2bcd8739ae039;




/** Provides details of continuous extracted tail */ class $81952e4a4da5ff65$export$2e2bcd8739ae039 {
    /** Tail value as string */ /** Tail start position */ /** Start position */ constructor(value, from, stop){
        if (value === void 0) value = "";
        if (from === void 0) from = 0;
        this.value = value;
        this.from = from;
        this.stop = stop;
    }
    toString() {
        return this.value;
    }
    extend(tail) {
        this.value += String(tail);
    }
    appendTo(masked) {
        return masked.append(this.toString(), {
            tail: true
        }).aggregate(masked._appendPlaceholder());
    }
    get state() {
        return {
            value: this.value,
            from: this.from,
            stop: this.stop
        };
    }
    set state(state) {
        Object.assign(this, state);
    }
    unshift(beforePos) {
        if (!this.value.length || beforePos != null && this.from >= beforePos) return "";
        const shiftChar = this.value[0];
        this.value = this.value.slice(1);
        return shiftChar;
    }
    shift() {
        if (!this.value.length) return "";
        const shiftChar = this.value[this.value.length - 1];
        this.value = this.value.slice(0, -1);
        return shiftChar;
    }
}




/** Append flags */ /** Extract flags */ // see https://github.com/microsoft/TypeScript/issues/6223
/** Provides common masking stuff */ class $18a6c62942791a59$export$2e2bcd8739ae039 {
    /** */ /** */ /** Transforms value before mask processing */ /** Transforms each char before mask processing */ /** Validates if value is acceptable */ /** Does additional processing at the end of editing */ /** Format typed value to string */ /** Parse string to get typed value */ /** Enable characters overwriting */ /** */ /** */ /** */ constructor(opts){
        this._value = "";
        this._update({
            ...$18a6c62942791a59$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this._initialized = true;
    }
    /** Sets and applies new options */ updateOptions(opts) {
        if (!Object.keys(opts).length) return;
        this.withValueRefresh(this._update.bind(this, opts));
    }
    /** Sets new options */ _update(opts) {
        Object.assign(this, opts);
    }
    /** Mask state */ get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
    }
    /** Resets value */ reset() {
        this._value = "";
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this.resolve(value, {
            input: true
        });
    }
    /** Resolve new value */ resolve(value, flags) {
        if (flags === void 0) flags = {
            input: true
        };
        this.reset();
        this.append(value, flags, "");
        this.doCommit();
    }
    get unmaskedValue() {
        return this.value;
    }
    set unmaskedValue(value) {
        this.resolve(value, {});
    }
    get typedValue() {
        return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
    }
    set typedValue(value) {
        if (this.format) this.value = this.format(value, this);
        else this.unmaskedValue = String(value);
    }
    /** Value that includes raw user input */ get rawInputValue() {
        return this.extractInput(0, this.displayValue.length, {
            raw: true
        });
    }
    set rawInputValue(value) {
        this.resolve(value, {
            raw: true
        });
    }
    get displayValue() {
        return this.value;
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return this.isComplete;
    }
    /** Finds nearest input position in direction */ nearestInputPos(cursorPos, direction) {
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return Math.min(this.displayValue.length, toPos - fromPos);
    }
    /** Extracts value in range considering flags */ extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return this.displayValue.slice(fromPos, toPos);
    }
    /** Extracts tail in range */ extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return new (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)(this.extractInput(fromPos, toPos), fromPos);
    }
    /** Appends tail */ appendTail(tail) {
        if ((0, $b9f82b1f38a24931$export$844ec244b1367d54)(tail)) tail = new (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    /** Appends char */ _appendCharRaw(ch, flags) {
        if (!ch) return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        this._value += ch;
        return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)({
            inserted: ch,
            rawInserted: ch
        });
    }
    /** Appends char */ _appendChar(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const consistentState = this.state;
        let details;
        [ch, details] = this.doPrepareChar(ch, flags);
        details = details.aggregate(this._appendCharRaw(ch, flags));
        if (details.inserted) {
            let consistentTail;
            let appended = this.doValidate(flags) !== false;
            if (appended && checkTail != null) {
                // validation ok, check tail
                const beforeTailState = this.state;
                if (this.overwrite === true) {
                    consistentTail = checkTail.state;
                    checkTail.unshift(this.displayValue.length - details.tailShift);
                }
                let tailDetails = this.appendTail(checkTail);
                appended = tailDetails.rawInserted === checkTail.toString();
                // not ok, try shift
                if (!(appended && tailDetails.inserted) && this.overwrite === "shift") {
                    this.state = beforeTailState;
                    consistentTail = checkTail.state;
                    checkTail.shift();
                    tailDetails = this.appendTail(checkTail);
                    appended = tailDetails.rawInserted === checkTail.toString();
                }
                // if ok, rollback state after tail
                if (appended && tailDetails.inserted) this.state = beforeTailState;
            }
            // revert all if something went wrong
            if (!appended) {
                details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
                this.state = consistentState;
                if (checkTail && consistentTail) checkTail.state = consistentTail;
            }
        }
        return details;
    }
    /** Appends optional placeholder at the end */ _appendPlaceholder() {
        return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
    }
    /** Appends optional eager placeholder at the end */ _appendEager() {
        return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
    }
    /** Appends symbols considering flags */ append(str, flags, tail) {
        if (!(0, $b9f82b1f38a24931$export$844ec244b1367d54)(str)) throw new Error("value should be string");
        const checkTail = (0, $b9f82b1f38a24931$export$844ec244b1367d54)(tail) ? new (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)(String(tail)) : tail;
        if (flags != null && flags.tail) flags._beforeTailState = this.state;
        let details;
        [str, details] = this.doPrepare(str, flags);
        for(let ci = 0; ci < str.length; ++ci){
            const d = this._appendChar(str[ci], flags, checkTail);
            if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
            details.aggregate(d);
        }
        if ((this.eager === true || this.eager === "append") && flags != null && flags.input && str) details.aggregate(this._appendEager());
        // append tail but aggregate only tailShift
        if (checkTail != null) details.tailShift += this.appendTail(checkTail).tailShift;
        return details;
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
        return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
    }
    /** Calls function and reapplies current value */ withValueRefresh(fn) {
        if (this._refreshing || !this._initialized) return fn();
        this._refreshing = true;
        const rawInput = this.rawInputValue;
        const value = this.value;
        const ret = fn();
        this.rawInputValue = rawInput;
        // append lost trailing chars at the end
        if (this.value && this.value !== value && value.indexOf(this.value) === 0) this.append(value.slice(this.displayValue.length), {}, "");
        delete this._refreshing;
        return ret;
    }
    runIsolated(fn) {
        if (this._isolated || !this._initialized) return fn(this);
        this._isolated = true;
        const state = this.state;
        const ret = fn(this);
        this.state = state;
        delete this._isolated;
        return ret;
    }
    doSkipInvalid(ch, flags, checkTail) {
        return Boolean(this.skipInvalid);
    }
    /** Prepares string before mask processing */ doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $bd3b02e030d373d5$export$2e2bcd8739ae039).normalize(this.prepare ? this.prepare(str, this, flags) : str);
    }
    /** Prepares each char before mask processing */ doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $bd3b02e030d373d5$export$2e2bcd8739ae039).normalize(this.prepareChar ? this.prepareChar(str, this, flags) : str);
    }
    /** Validates if value is acceptable */ doValidate(flags) {
        return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
    /** Does additional processing at the end of editing */ doCommit() {
        if (this.commit) this.commit(this.value, this);
    }
    splice(start, deleteCount, inserted, removeDirection, flags) {
        if (removeDirection === void 0) removeDirection = (0, $b9f82b1f38a24931$export$9106728c49045482).NONE;
        if (flags === void 0) flags = {
            input: true
        };
        const tailPos = start + deleteCount;
        const tail = this.extractTail(tailPos);
        const eagerRemove = this.eager === true || this.eager === "remove";
        let oldRawValue;
        if (eagerRemove) {
            removeDirection = (0, $b9f82b1f38a24931$export$32af4dafed14c8ce)(removeDirection);
            oldRawValue = this.extractInput(0, tailPos, {
                raw: true
            });
        }
        let startChangePos = start;
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        // if it is just deletion without insertion
        if (removeDirection !== (0, $b9f82b1f38a24931$export$9106728c49045482).NONE) {
            startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? (0, $b9f82b1f38a24931$export$9106728c49045482).NONE : removeDirection);
            // adjust tailShift if start was aligned
            details.tailShift = startChangePos - start;
        }
        details.aggregate(this.remove(startChangePos));
        if (eagerRemove && removeDirection !== (0, $b9f82b1f38a24931$export$9106728c49045482).NONE && oldRawValue === this.rawInputValue) {
            if (removeDirection === (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT) {
                let valLength;
                while(oldRawValue === this.rawInputValue && (valLength = this.displayValue.length))details.aggregate(new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)({
                    tailShift: -1
                })).aggregate(this.remove(valLength - 1));
            } else if (removeDirection === (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_RIGHT) tail.unshift();
        }
        return details.aggregate(this.append(inserted, flags, tail));
    }
    maskEquals(mask) {
        return this.mask === mask;
    }
    typedValueEquals(value) {
        const tval = this.typedValue;
        return value === tval || $18a6c62942791a59$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $18a6c62942791a59$export$2e2bcd8739ae039.EMPTY_VALUES.includes(tval) || (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false);
    }
}
$18a6c62942791a59$export$2e2bcd8739ae039.DEFAULTS = {
    skipInvalid: true
};
$18a6c62942791a59$export$2e2bcd8739ae039.EMPTY_VALUES = [
    undefined,
    null,
    ""
];
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).Masked = $18a6c62942791a59$export$2e2bcd8739ae039;











class $987e1259c87a2a38$export$2e2bcd8739ae039 {
    /** */ constructor(chunks, from){
        if (chunks === void 0) chunks = [];
        if (from === void 0) from = 0;
        this.chunks = chunks;
        this.from = from;
    }
    toString() {
        return this.chunks.map(String).join("");
    }
    extend(tailChunk) {
        if (!String(tailChunk)) return;
        tailChunk = (0, $b9f82b1f38a24931$export$844ec244b1367d54)(tailChunk) ? new (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)(String(tailChunk)) : tailChunk;
        const lastChunk = this.chunks[this.chunks.length - 1];
        const extendLast = lastChunk && // if stops are same or tail has no stop
        (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
        tailChunk.from === lastChunk.from + lastChunk.toString().length;
        if (tailChunk instanceof (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)) {
            // check the ability to extend previous chunk
            if (extendLast) // extend previous chunk
            lastChunk.extend(tailChunk.toString());
            else // append new chunk
            this.chunks.push(tailChunk);
        } else if (tailChunk instanceof $987e1259c87a2a38$export$2e2bcd8739ae039) {
            if (tailChunk.stop == null) {
                // unwrap floating chunks to parent, keeping `from` pos
                let firstTailChunk;
                while(tailChunk.chunks.length && tailChunk.chunks[0].stop == null){
                    firstTailChunk = tailChunk.chunks.shift(); // not possible to be `undefined` because length was checked above
                    firstTailChunk.from += tailChunk.from;
                    this.extend(firstTailChunk);
                }
            }
            // if tail chunk still has value
            if (tailChunk.toString()) {
                // if chunks contains stops, then popup stop to container
                tailChunk.stop = tailChunk.blockIndex;
                this.chunks.push(tailChunk);
            }
        }
    }
    appendTo(masked) {
        if (!(masked instanceof (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedPattern)) {
            const tail = new (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)(this.toString());
            return tail.appendTo(masked);
        }
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        for(let ci = 0; ci < this.chunks.length && !details.skip; ++ci){
            const chunk = this.chunks[ci];
            const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
            const stop = chunk.stop;
            let chunkBlock;
            if (stop != null && // if block not found or stop is behind lastBlock
            (!lastBlockIter || lastBlockIter.index <= stop)) {
                if (chunk instanceof $987e1259c87a2a38$export$2e2bcd8739ae039 || // for continuous block also check if stop is exist
                masked._stops.indexOf(stop) >= 0) {
                    const phDetails = masked._appendPlaceholder(stop);
                    details.aggregate(phDetails);
                }
                chunkBlock = chunk instanceof $987e1259c87a2a38$export$2e2bcd8739ae039 && masked._blocks[stop];
            }
            if (chunkBlock) {
                const tailDetails = chunkBlock.appendTail(chunk);
                tailDetails.skip = false; // always ignore skip, it will be set on last
                details.aggregate(tailDetails);
                masked._value += tailDetails.inserted;
                // get not inserted chars
                const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
                if (remainChars) details.aggregate(masked.append(remainChars, {
                    tail: true
                }));
            } else details.aggregate(masked.append(chunk.toString(), {
                tail: true
            }));
        }
        return details;
    }
    get state() {
        return {
            chunks: this.chunks.map((c)=>c.state),
            from: this.from,
            stop: this.stop,
            blockIndex: this.blockIndex
        };
    }
    set state(state) {
        const { chunks: chunks, ...props } = state;
        Object.assign(this, props);
        this.chunks = chunks.map((cstate)=>{
            const chunk = "chunks" in cstate ? new $987e1259c87a2a38$export$2e2bcd8739ae039() : new (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)();
            chunk.state = cstate;
            return chunk;
        });
    }
    unshift(beforePos) {
        if (!this.chunks.length || beforePos != null && this.from >= beforePos) return "";
        const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
        let ci = 0;
        while(ci < this.chunks.length){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.unshift(chunkShiftPos);
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                ++ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return "";
    }
    shift() {
        if (!this.chunks.length) return "";
        let ci = this.chunks.length - 1;
        while(0 <= ci){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.shift();
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                --ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return "";
    }
}



class $9a02baa154032bcf$export$2e2bcd8739ae039 {
    constructor(masked, pos){
        this.masked = masked;
        this._log = [];
        const { offset: offset, index: index } = masked._mapPosToBlock(pos) || (pos < 0 ? // first
        {
            index: 0,
            offset: 0
        } : // last
        {
            index: this.masked._blocks.length,
            offset: 0
        });
        this.offset = offset;
        this.index = index;
        this.ok = false;
    }
    get block() {
        return this.masked._blocks[this.index];
    }
    get pos() {
        return this.masked._blockStartPos(this.index) + this.offset;
    }
    get state() {
        return {
            index: this.index,
            offset: this.offset,
            ok: this.ok
        };
    }
    set state(s) {
        Object.assign(this, s);
    }
    pushState() {
        this._log.push(this.state);
    }
    popState() {
        const s = this._log.pop();
        if (s) this.state = s;
        return s;
    }
    bindBlock() {
        if (this.block) return;
        if (this.index < 0) {
            this.index = 0;
            this.offset = 0;
        }
        if (this.index >= this.masked._blocks.length) {
            this.index = this.masked._blocks.length - 1;
            this.offset = this.block.displayValue.length; // TODO this is stupid type error, `block` depends on index that was changed above
        }
    }
    _pushLeft(fn) {
        this.pushState();
        for(this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0){
            var _this$block;
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    _pushRight(fn) {
        this.pushState();
        for(this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0){
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    pushLeftBeforeFilled() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT);
            if (this.offset !== 0) return true;
        });
    }
    pushLeftBeforeInput() {
        // cases:
        // filled input: 00|
        // optional empty input: 00[]|
        // nested block: XX<[]>|
        return this._pushLeft(()=>{
            if (this.block.isFixed) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushLeftBeforeRequired() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushRightBeforeFilled() {
        return this._pushRight(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_RIGHT);
            if (this.offset !== this.block.value.length) return true;
        });
    }
    pushRightBeforeInput() {
        return this._pushRight(()=>{
            if (this.block.isFixed) return;
            // const o = this.offset;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b9f82b1f38a24931$export$9106728c49045482).NONE);
            // HACK cases like (STILL DOES NOT WORK FOR NESTED)
            // aa|X
            // aa<X|[]>X_    - this will not work
            // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
            return true;
        });
    }
    pushRightBeforeRequired() {
        return this._pushRight(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            // TODO check |[*]XX_
            this.offset = this.block.nearestInputPos(this.offset, (0, $b9f82b1f38a24931$export$9106728c49045482).NONE);
            return true;
        });
    }
}






class $1fb2c7b048288f37$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        Object.assign(this, opts);
        this._value = "";
        this.isFixed = true;
    }
    get value() {
        return this._value;
    }
    get unmaskedValue() {
        return this.isUnmasking ? this.value : "";
    }
    get rawInputValue() {
        return this._isRawInput ? this.value : "";
    }
    get displayValue() {
        return this.value;
    }
    reset() {
        this._isRawInput = false;
        this._value = "";
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
        if (!this._value) this._isRawInput = false;
        return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b9f82b1f38a24931$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this._value.length;
        switch(direction){
            case (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT:
            case (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT:
                return minPos;
            case (0, $b9f82b1f38a24931$export$9106728c49045482).NONE:
            case (0, $b9f82b1f38a24931$export$9106728c49045482).RIGHT:
            case (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_RIGHT:
            default:
                return maxPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        return this._isRawInput ? toPos - fromPos : 0;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        if (flags === void 0) flags = {};
        return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || "";
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return Boolean(this._value);
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        if (this.isFilled) return details;
        const appendEager = this.eager === true || this.eager === "append";
        const appended = this.char === ch;
        const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
        if (isResolved) details.rawInserted = this.char;
        this._value = details.inserted = this.char;
        this._isRawInput = isResolved && (flags.raw || flags.input);
        return details;
    }
    _appendEager() {
        return this._appendChar(this.char, {
            tail: true
        });
    }
    _appendPlaceholder() {
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        if (this.isFilled) return details;
        this._value = details.inserted = this.char;
        return details;
    }
    extractTail() {
        return new (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)("");
    }
    appendTail(tail) {
        if ((0, $b9f82b1f38a24931$export$844ec244b1367d54)(tail)) tail = new (0, $81952e4a4da5ff65$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    append(str, flags, tail) {
        const details = this._appendChar(str[0], flags);
        if (tail != null) details.tailShift += this.appendTail(tail).tailShift;
        return details;
    }
    doCommit() {}
    get state() {
        return {
            _value: this._value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
        this._isRawInput = Boolean(state._rawInputValue);
    }
}






class $82a2e1550ae7feb1$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        const { parent: parent, isOptional: isOptional, placeholderChar: placeholderChar, displayChar: displayChar, lazy: lazy, eager: eager, ...maskOpts } = opts;
        this.masked = (0, $9b2a7934382d129f$export$2e2bcd8739ae039)(maskOpts);
        Object.assign(this, {
            parent: parent,
            isOptional: isOptional,
            placeholderChar: placeholderChar,
            displayChar: displayChar,
            lazy: lazy,
            eager: eager
        });
    }
    reset() {
        this.isFilled = false;
        this.masked.reset();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        if (fromPos === 0 && toPos >= 1) {
            this.isFilled = false;
            return this.masked.remove(fromPos, toPos);
        }
        return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
    }
    get value() {
        return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
    }
    get unmaskedValue() {
        return this.masked.unmaskedValue;
    }
    get rawInputValue() {
        return this.masked.rawInputValue;
    }
    get displayValue() {
        return this.masked.value && this.displayChar || this.value;
    }
    get isComplete() {
        return Boolean(this.masked.value) || this.isOptional;
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        const state = this.masked.state;
        // simulate input
        const details = this.masked._appendChar(ch, this.currentMaskFlags(flags));
        if (details.inserted && this.doValidate(flags) === false) {
            details.inserted = details.rawInserted = "";
            this.masked.state = state;
        }
        if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) details.inserted = this.placeholderChar;
        details.skip = !details.inserted && !this.isOptional;
        this.isFilled = Boolean(details.inserted);
        return details;
    }
    append(str, flags, tail) {
        // TODO probably should be done via _appendChar
        return this.masked.append(str, this.currentMaskFlags(flags), tail);
    }
    _appendPlaceholder() {
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        if (this.isFilled || this.isOptional) return details;
        this.isFilled = true;
        details.inserted = this.placeholderChar;
        return details;
    }
    _appendEager() {
        return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
    }
    extractTail(fromPos, toPos) {
        return this.masked.extractTail(fromPos, toPos);
    }
    appendTail(tail) {
        return this.masked.appendTail(tail);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.masked.extractInput(fromPos, toPos, flags);
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b9f82b1f38a24931$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this.value.length;
        const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
        switch(direction){
            case (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT:
            case (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT:
                return this.isComplete ? boundPos : minPos;
            case (0, $b9f82b1f38a24931$export$9106728c49045482).RIGHT:
            case (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_RIGHT:
                return this.isComplete ? boundPos : maxPos;
            case (0, $b9f82b1f38a24931$export$9106728c49045482).NONE:
            default:
                return boundPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.value.slice(fromPos, toPos).length;
    }
    doValidate(flags) {
        return this.masked.doValidate(this.currentMaskFlags(flags)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags)));
    }
    doCommit() {
        this.masked.doCommit();
    }
    get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue,
            masked: this.masked.state,
            isFilled: this.isFilled
        };
    }
    set state(state) {
        this.masked.state = state.masked;
        this.isFilled = state.isFilled;
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta;
        return {
            ...flags,
            _beforeTailState: (flags == null || (_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.masked) || (flags == null ? void 0 : flags._beforeTailState)
        };
    }
}
$82a2e1550ae7feb1$export$2e2bcd8739ae039.DEFAULT_DEFINITIONS = {
    "0": /\d/,
    "a": /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // http://stackoverflow.com/a/22075070
    "*": /./
};







/** Masking by RegExp */ class $3e17a068903da490$export$2e2bcd8739ae039 extends (0, $18a6c62942791a59$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const mask = opts.mask;
        if (mask) opts.validate = (value)=>value.search(mask) >= 0;
        super._update(opts);
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedRegExp = $3e17a068903da490$export$2e2bcd8739ae039;



/** Pattern mask */ class $a593d1cc05cf62bc$export$2e2bcd8739ae039 extends (0, $18a6c62942791a59$export$2e2bcd8739ae039) {
    /** */ /** */ /** Single char for empty input */ /** Single char for filled input */ /** Show placeholder only when needed */ /** Enable characters overwriting */ /** */ /** */ constructor(opts){
        super({
            ...$a593d1cc05cf62bc$export$2e2bcd8739ae039.DEFAULTS,
            ...opts,
            definitions: Object.assign({}, (0, $82a2e1550ae7feb1$export$2e2bcd8739ae039).DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        opts.definitions = Object.assign({}, this.definitions, opts.definitions);
        super._update(opts);
        this._rebuildMask();
    }
    _rebuildMask() {
        const defs = this.definitions;
        this._blocks = [];
        this.exposeBlock = undefined;
        this._stops = [];
        this._maskedBlocks = {};
        const pattern = this.mask;
        if (!pattern || !defs) return;
        let unmaskingBlock = false;
        let optionalBlock = false;
        for(let i = 0; i < pattern.length; ++i){
            if (this.blocks) {
                const p = pattern.slice(i);
                const bNames = Object.keys(this.blocks).filter((bName)=>p.indexOf(bName) === 0);
                // order by key length
                bNames.sort((a, b)=>b.length - a.length);
                // use block name with max length
                const bName = bNames[0];
                if (bName) {
                    const { expose: expose, ...blockOpts } = (0, $9b2a7934382d129f$export$a213ae1c699d7230)(this.blocks[bName]);
                    const maskedBlock = (0, $9b2a7934382d129f$export$2e2bcd8739ae039)({
                        lazy: this.lazy,
                        eager: this.eager,
                        placeholderChar: this.placeholderChar,
                        displayChar: this.displayChar,
                        overwrite: this.overwrite,
                        ...blockOpts,
                        parent: this
                    });
                    if (maskedBlock) {
                        this._blocks.push(maskedBlock);
                        if (expose) this.exposeBlock = maskedBlock;
                        // store block index
                        if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
                        this._maskedBlocks[bName].push(this._blocks.length - 1);
                    }
                    i += bName.length - 1;
                    continue;
                }
            }
            let char = pattern[i];
            let isInput = char in defs;
            if (char === $a593d1cc05cf62bc$export$2e2bcd8739ae039.STOP_CHAR) {
                this._stops.push(this._blocks.length);
                continue;
            }
            if (char === "{" || char === "}") {
                unmaskingBlock = !unmaskingBlock;
                continue;
            }
            if (char === "[" || char === "]") {
                optionalBlock = !optionalBlock;
                continue;
            }
            if (char === $a593d1cc05cf62bc$export$2e2bcd8739ae039.ESCAPE_CHAR) {
                ++i;
                char = pattern[i];
                if (!char) break;
                isInput = false;
            }
            const def = isInput ? new (0, $82a2e1550ae7feb1$export$2e2bcd8739ae039)({
                isOptional: optionalBlock,
                lazy: this.lazy,
                eager: this.eager,
                placeholderChar: this.placeholderChar,
                displayChar: this.displayChar,
                ...(0, $9b2a7934382d129f$export$a213ae1c699d7230)(defs[char]),
                parent: this
            }) : new (0, $1fb2c7b048288f37$export$2e2bcd8739ae039)({
                char: char,
                eager: this.eager,
                isUnmasking: unmaskingBlock
            });
            this._blocks.push(def);
        }
    }
    get state() {
        return {
            ...super.state,
            _blocks: this._blocks.map((b)=>b.state)
        };
    }
    set state(state) {
        const { _blocks: _blocks, ...maskedState } = state;
        this._blocks.forEach((b, bi)=>b.state = _blocks[bi]);
        super.state = maskedState;
    }
    reset() {
        super.reset();
        this._blocks.forEach((b)=>b.reset());
    }
    get isComplete() {
        return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((b)=>b.isComplete);
    }
    get isFilled() {
        return this._blocks.every((b)=>b.isFilled);
    }
    get isFixed() {
        return this._blocks.every((b)=>b.isFixed);
    }
    get isOptional() {
        return this._blocks.every((b)=>b.isOptional);
    }
    doCommit() {
        this._blocks.forEach((b)=>b.doCommit());
        super.doCommit();
    }
    get unmaskedValue() {
        return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((str, b)=>str += b.unmaskedValue, "");
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.unmaskedValue = unmaskedValue;
            this.appendTail(tail);
            this.doCommit();
        } else super.unmaskedValue = unmaskedValue;
    }
    get value() {
        return this.exposeBlock ? this.exposeBlock.value : // TODO return _value when not in change?
        this._blocks.reduce((str, b)=>str += b.value, "");
    }
    set value(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.value = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.value = value;
    }
    get typedValue() {
        return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
    }
    set typedValue(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.typedValue = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.typedValue = value;
    }
    get displayValue() {
        return this._blocks.reduce((str, b)=>str += b.displayValue, "");
    }
    appendTail(tail) {
        return super.appendTail(tail).aggregate(this._appendPlaceholder());
    }
    _appendEager() {
        var _this$_mapPosToBlock;
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
        if (startBlockIndex == null) return details;
        // TODO test if it works for nested pattern masks
        if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
        for(let bi = startBlockIndex; bi < this._blocks.length; ++bi){
            const d = this._blocks[bi]._appendEager();
            if (!d.inserted) break;
            details.aggregate(d);
        }
        return details;
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const blockIter = this._mapPosToBlock(this.displayValue.length);
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        if (!blockIter) return details;
        for(let bi = blockIter.index;; ++bi){
            var _flags$_beforeTailSta;
            const block = this._blocks[bi];
            if (!block) break;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            const skip = blockDetails.skip;
            details.aggregate(blockDetails);
            if (skip || blockDetails.rawInserted) break; // go next char
        }
        return details;
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const chunkTail = new (0, $987e1259c87a2a38$export$2e2bcd8739ae039)();
        if (fromPos === toPos) return chunkTail;
        this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos)=>{
            const blockChunk = b.extractTail(bFromPos, bToPos);
            blockChunk.stop = this._findStopBefore(bi);
            blockChunk.from = this._blockStartPos(bi);
            if (blockChunk instanceof (0, $987e1259c87a2a38$export$2e2bcd8739ae039)) blockChunk.blockIndex = bi;
            chunkTail.extend(blockChunk);
        });
        return chunkTail;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (flags === void 0) flags = {};
        if (fromPos === toPos) return "";
        let input = "";
        this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos)=>{
            input += b.extractInput(fromPos, toPos, flags);
        });
        return input;
    }
    _findStopBefore(blockIndex) {
        let stopBefore;
        for(let si = 0; si < this._stops.length; ++si){
            const stop = this._stops[si];
            if (stop <= blockIndex) stopBefore = stop;
            else break;
        }
        return stopBefore;
    }
    /** Appends placeholder depending on laziness */ _appendPlaceholder(toBlockIndex) {
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        if (this.lazy && toBlockIndex == null) return details;
        const startBlockIter = this._mapPosToBlock(this.displayValue.length);
        if (!startBlockIter) return details;
        const startBlockIndex = startBlockIter.index;
        const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
        this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b)=>{
            if (!b.lazy || toBlockIndex != null) {
                var _blocks2;
                const bDetails = b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length);
                this._value += bDetails.inserted;
                details.aggregate(bDetails);
            }
        });
        return details;
    }
    /** Finds block in pos */ _mapPosToBlock(pos) {
        let accVal = "";
        for(let bi = 0; bi < this._blocks.length; ++bi){
            const block = this._blocks[bi];
            const blockStartPos = accVal.length;
            accVal += block.displayValue;
            if (pos <= accVal.length) return {
                index: bi,
                offset: pos - blockStartPos
            };
        }
    }
    _blockStartPos(blockIndex) {
        return this._blocks.slice(0, blockIndex).reduce((pos, b)=>pos += b.displayValue.length, 0);
    }
    _forEachBlocksInRange(fromPos, toPos, fn) {
        if (toPos === void 0) toPos = this.displayValue.length;
        const fromBlockIter = this._mapPosToBlock(fromPos);
        if (fromBlockIter) {
            const toBlockIter = this._mapPosToBlock(toPos);
            // process first block
            const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
            const fromBlockStartPos = fromBlockIter.offset;
            const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
            fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
            if (toBlockIter && !isSameBlock) {
                // process intermediate blocks
                for(let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi)fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
                // process last block
                fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
            }
        }
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            removeDetails.aggregate(b.remove(bFromPos, bToPos));
        });
        return removeDetails;
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b9f82b1f38a24931$export$9106728c49045482).NONE;
        if (!this._blocks.length) return 0;
        const cursor = new (0, $9a02baa154032bcf$export$2e2bcd8739ae039)(this, cursorPos);
        if (direction === (0, $b9f82b1f38a24931$export$9106728c49045482).NONE) {
            // -------------------------------------------------
            // NONE should only go out from fixed to the right!
            // -------------------------------------------------
            if (cursor.pushRightBeforeInput()) return cursor.pos;
            cursor.popState();
            if (cursor.pushLeftBeforeInput()) return cursor.pos;
            return this.displayValue.length;
        }
        // FORCE is only about a|* otherwise is 0
        if (direction === (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT || direction === (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT) {
            // try to break fast when *|a
            if (direction === (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeFilled();
                if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
                cursor.popState();
            }
            // forward flow
            cursor.pushLeftBeforeInput();
            cursor.pushLeftBeforeRequired();
            cursor.pushLeftBeforeFilled();
            // backward flow
            if (direction === (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeInput();
                cursor.pushRightBeforeRequired();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
            }
            if (cursor.ok) return cursor.pos;
            if (direction === (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT) return 0;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return 0;
        }
        if (direction === (0, $b9f82b1f38a24931$export$9106728c49045482).RIGHT || direction === (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_RIGHT) {
            // forward flow
            cursor.pushRightBeforeInput();
            cursor.pushRightBeforeRequired();
            if (cursor.pushRightBeforeFilled()) return cursor.pos;
            if (direction === (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_RIGHT) return this.displayValue.length;
            // backward flow
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return this.nearestInputPos(cursorPos, (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT);
        }
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        let total = 0;
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            total += b.totalInputPositions(bFromPos, bToPos);
        });
        return total;
    }
    /** Get block by name */ maskedBlock(name) {
        return this.maskedBlocks(name)[0];
    }
    /** Get all blocks by name */ maskedBlocks(name) {
        const indices = this._maskedBlocks[name];
        if (!indices) return [];
        return indices.map((gi)=>this._blocks[gi]);
    }
}
$a593d1cc05cf62bc$export$2e2bcd8739ae039.DEFAULTS = {
    lazy: true,
    placeholderChar: "_"
};
$a593d1cc05cf62bc$export$2e2bcd8739ae039.STOP_CHAR = "`";
$a593d1cc05cf62bc$export$2e2bcd8739ae039.ESCAPE_CHAR = "\\";
$a593d1cc05cf62bc$export$2e2bcd8739ae039.InputDefinition = (0, $82a2e1550ae7feb1$export$2e2bcd8739ae039);
$a593d1cc05cf62bc$export$2e2bcd8739ae039.FixedDefinition = (0, $1fb2c7b048288f37$export$2e2bcd8739ae039);
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedPattern = $a593d1cc05cf62bc$export$2e2bcd8739ae039;














/** Pattern which accepts ranges */ class $1fecf9d7bab406f0$export$2e2bcd8739ae039 extends (0, $a593d1cc05cf62bc$export$2e2bcd8739ae039) {
    /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */ /** Min bound */ /** Max bound */ /** */ get _matchFrom() {
        return this.maxLength - String(this.from).length;
    }
    constructor(opts){
        super(opts); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { to: to = this.to || 0, from: from = this.from || 0, maxLength: maxLength = this.maxLength || 0, autofix: autofix = this.autofix, ...patternOpts } = opts;
        this.to = to;
        this.from = from;
        this.maxLength = Math.max(String(to).length, maxLength);
        this.autofix = autofix;
        const fromStr = String(this.from).padStart(this.maxLength, "0");
        const toStr = String(this.to).padStart(this.maxLength, "0");
        let sameCharsCount = 0;
        while(sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount])++sameCharsCount;
        patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, "\\0") + "0".repeat(this.maxLength - sameCharsCount);
        super._update(patternOpts);
    }
    get isComplete() {
        return super.isComplete && Boolean(this.value);
    }
    boundaries(str) {
        let minstr = "";
        let maxstr = "";
        const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
        if (num) {
            minstr = "0".repeat(placeholder.length) + num;
            maxstr = "9".repeat(placeholder.length) + num;
        }
        minstr = minstr.padEnd(this.maxLength, "0");
        maxstr = maxstr.padEnd(this.maxLength, "9");
        return [
            minstr,
            maxstr
        ];
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        let details;
        [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ""), flags);
        if (!this.autofix || !ch) return [
            ch,
            details
        ];
        const fromStr = String(this.from).padStart(this.maxLength, "0");
        const toStr = String(this.to).padStart(this.maxLength, "0");
        const nextVal = this.value + ch;
        if (nextVal.length > this.maxLength) return [
            "",
            details
        ];
        const [minstr, maxstr] = this.boundaries(nextVal);
        if (Number(maxstr) < this.from) return [
            fromStr[nextVal.length - 1],
            details
        ];
        if (Number(minstr) > this.to) {
            if (this.autofix === "pad" && nextVal.length < this.maxLength) return [
                "",
                details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))
            ];
            return [
                toStr[nextVal.length - 1],
                details
            ];
        }
        return [
            ch,
            details
        ];
    }
    doValidate(flags) {
        const str = this.value;
        const firstNonZero = str.search(/[^0]/);
        if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
        const [minstr, maxstr] = this.boundaries(str);
        return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags);
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedRange = $1fecf9d7bab406f0$export$2e2bcd8739ae039;













/** Date mask */ class $dc338e4b295b7779$export$2e2bcd8739ae039 extends (0, $a593d1cc05cf62bc$export$2e2bcd8739ae039) {
    /** Pattern mask for date according to {@link MaskedDate#format} */ /** Start date */ /** End date */ /** */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        const { mask: mask, pattern: pattern, ...patternOpts } = {
            ...$dc338e4b295b7779$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        };
        super({
            ...patternOpts,
            mask: (0, $b9f82b1f38a24931$export$844ec244b1367d54)(mask) ? mask : pattern
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { mask: mask, pattern: pattern, blocks: blocks, ...patternOpts } = {
            ...$dc338e4b295b7779$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        };
        const patternBlocks = Object.assign({}, $dc338e4b295b7779$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS());
        // adjust year block
        if (opts.min) patternBlocks.Y.from = opts.min.getFullYear();
        if (opts.max) patternBlocks.Y.to = opts.max.getFullYear();
        if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
            patternBlocks.m.from = opts.min.getMonth() + 1;
            patternBlocks.m.to = opts.max.getMonth() + 1;
            if (patternBlocks.m.from === patternBlocks.m.to) {
                patternBlocks.d.from = opts.min.getDate();
                patternBlocks.d.to = opts.max.getDate();
            }
        }
        Object.assign(patternBlocks, this.blocks, blocks);
        // add autofix
        Object.keys(patternBlocks).forEach((bk)=>{
            const b = patternBlocks[bk];
            if (!("autofix" in b) && "autofix" in opts) b.autofix = opts.autofix;
        });
        super._update({
            ...patternOpts,
            mask: (0, $b9f82b1f38a24931$export$844ec244b1367d54)(mask) ? mask : pattern,
            blocks: patternBlocks
        });
    }
    doValidate(flags) {
        const date = this.date;
        return super.doValidate(flags) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
    /** Checks if date is exists */ isDateExist(str) {
        return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
    /** Parsed Date */ get date() {
        return this.typedValue;
    }
    set date(date) {
        this.typedValue = date;
    }
    get typedValue() {
        return this.isComplete ? super.typedValue : null;
    }
    set typedValue(value) {
        super.typedValue = value;
    }
    maskEquals(mask) {
        return mask === Date || super.maskEquals(mask);
    }
}
$dc338e4b295b7779$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS = ()=>({
        d: {
            mask: (0, $1fecf9d7bab406f0$export$2e2bcd8739ae039),
            from: 1,
            to: 31,
            maxLength: 2
        },
        m: {
            mask: (0, $1fecf9d7bab406f0$export$2e2bcd8739ae039),
            from: 1,
            to: 12,
            maxLength: 2
        },
        Y: {
            mask: (0, $1fecf9d7bab406f0$export$2e2bcd8739ae039),
            from: 1900,
            to: 9999
        }
    });
$dc338e4b295b7779$export$2e2bcd8739ae039.DEFAULTS = {
    mask: Date,
    pattern: "d{.}`m{.}`Y",
    format: (date, masked)=>{
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return [
            day,
            month,
            year
        ].join(".");
    },
    parse: (str, masked)=>{
        const [day, month, year] = str.split(".").map(Number);
        return new Date(year, month - 1, day);
    }
};
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedDate = $dc338e4b295b7779$export$2e2bcd8739ae039;








/** Dynamic mask for choosing appropriate mask in run-time */ class $7d499f714d762607$export$2e2bcd8739ae039 extends (0, $18a6c62942791a59$export$2e2bcd8739ae039) {
    /** Currently chosen mask */ /** Currently chosen mask */ /** Compliled {@link Masked} options */ /** Chooses {@link Masked} depending on input value */ constructor(opts){
        super({
            ...$7d499f714d762607$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this.currentMask = undefined;
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        if ("mask" in opts) {
            this.exposeMask = undefined;
            // mask could be totally dynamic with only `dispatch` option
            this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m)=>{
                const { expose: expose, ...maskOpts } = (0, $9b2a7934382d129f$export$a213ae1c699d7230)(m);
                const masked = (0, $9b2a7934382d129f$export$2e2bcd8739ae039)({
                    overwrite: this._overwrite,
                    eager: this._eager,
                    skipInvalid: this._skipInvalid,
                    ...maskOpts
                });
                if (expose) this.exposeMask = masked;
                return masked;
            }) : [];
        // this.currentMask = this.doDispatch(''); // probably not needed but lets see
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = this._applyDispatch(ch, flags);
        if (this.currentMask) details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
        return details;
    }
    _applyDispatch(appended, flags, tail) {
        if (appended === void 0) appended = "";
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = "";
        const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
        const inputValue = this.rawInputValue;
        const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
        const tailValue = inputValue.slice(insertValue.length);
        const prevMask = this.currentMask;
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        const prevMaskState = prevMask == null ? void 0 : prevMask.state;
        // clone flags to prevent overwriting `_beforeTailState`
        this.currentMask = this.doDispatch(appended, {
            ...flags
        }, tail);
        // restore state after dispatch
        if (this.currentMask) {
            if (this.currentMask !== prevMask) {
                // if mask changed reapply input
                this.currentMask.reset();
                if (insertValue) {
                    const d = this.currentMask.append(insertValue, {
                        raw: true
                    });
                    details.tailShift = d.inserted.length - prevValueBeforeTail.length;
                }
                if (tailValue) details.tailShift += this.currentMask.append(tailValue, {
                    raw: true,
                    tail: true
                }).tailShift;
            } else if (prevMaskState) // Dispatch can do something bad with state, so
            // restore prev mask state
            this.currentMask.state = prevMaskState;
        }
        return details;
    }
    _appendPlaceholder() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendPlaceholder());
        return details;
    }
    _appendEager() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendEager());
        return details;
    }
    appendTail(tail) {
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        if (tail) details.aggregate(this._applyDispatch("", {}, tail));
        return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta, _flags$_beforeTailSta2;
        return {
            ...flags,
            _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
        };
    }
    doDispatch(appended, flags, tail) {
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = "";
        return this.dispatch(appended, this, flags, tail);
    }
    doValidate(flags) {
        return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
    doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepare(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepare(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepareChar(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepareChar(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    reset() {
        var _this$currentMask;
        (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
        this.compiledMasks.forEach((m)=>m.reset());
    }
    get value() {
        return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
    }
    set value(value) {
        if (this.exposeMask) {
            this.exposeMask.value = value;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.value = value;
    }
    get unmaskedValue() {
        return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeMask) {
            this.exposeMask.unmaskedValue = unmaskedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
    }
    set typedValue(typedValue) {
        if (this.exposeMask) {
            this.exposeMask.typedValue = typedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
            return;
        }
        let unmaskedValue = String(typedValue);
        // double check it
        if (this.currentMask) {
            this.currentMask.typedValue = typedValue;
            unmaskedValue = this.currentMask.unmaskedValue;
        }
        this.unmaskedValue = unmaskedValue;
    }
    get displayValue() {
        return this.currentMask ? this.currentMask.displayValue : "";
    }
    get isComplete() {
        var _this$currentMask2;
        return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
    }
    get isFilled() {
        var _this$currentMask3;
        return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
    }
    remove(fromPos, toPos) {
        const details = new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)();
        if (this.currentMask) details.aggregate(this.currentMask.remove(fromPos, toPos))// update with dispatch
        .aggregate(this._applyDispatch());
        return details;
    }
    get state() {
        var _this$currentMask4;
        return {
            ...super.state,
            _rawInputValue: this.rawInputValue,
            compiledMasks: this.compiledMasks.map((m)=>m.state),
            currentMaskRef: this.currentMask,
            currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
        };
    }
    set state(state) {
        const { compiledMasks: compiledMasks, currentMaskRef: currentMaskRef, currentMask: currentMask, ...maskedState } = state;
        if (compiledMasks) this.compiledMasks.forEach((m, mi)=>m.state = compiledMasks[mi]);
        if (currentMaskRef != null) {
            this.currentMask = currentMaskRef;
            this.currentMask.state = currentMask;
        }
        super.state = maskedState;
    }
    extractInput(fromPos, toPos, flags) {
        return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : "";
    }
    extractTail(fromPos, toPos) {
        return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
    }
    doCommit() {
        if (this.currentMask) this.currentMask.doCommit();
        super.doCommit();
    }
    nearestInputPos(cursorPos, direction) {
        return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : super.nearestInputPos(cursorPos, direction);
    }
    get overwrite() {
        return this.currentMask ? this.currentMask.overwrite : this._overwrite;
    }
    set overwrite(overwrite) {
        this._overwrite = overwrite;
    }
    get eager() {
        return this.currentMask ? this.currentMask.eager : this._eager;
    }
    set eager(eager) {
        this._eager = eager;
    }
    get skipInvalid() {
        return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
    }
    set skipInvalid(skipInvalid) {
        this._skipInvalid = skipInvalid;
    }
    maskEquals(mask) {
        return Array.isArray(mask) ? this.compiledMasks.every((m, mi)=>{
            if (!mask[mi]) return;
            const { mask: oldMask, ...restOpts } = mask[mi];
            return (0, $b9f82b1f38a24931$export$7aeb68f71172641d)(m, restOpts) && m.maskEquals(oldMask);
        }) : super.maskEquals(mask);
    }
    typedValueEquals(value) {
        var _this$currentMask5;
        return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
    }
}
$7d499f714d762607$export$2e2bcd8739ae039.DEFAULTS = void 0;
$7d499f714d762607$export$2e2bcd8739ae039.DEFAULTS = {
    dispatch: (appended, masked, flags, tail)=>{
        if (!masked.compiledMasks.length) return;
        const inputValue = masked.rawInputValue;
        // simulate input
        const inputs = masked.compiledMasks.map((m, index)=>{
            const isCurrent = masked.currentMask === m;
            const startInputPos = isCurrent ? m.displayValue.length : m.nearestInputPos(m.displayValue.length, (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT);
            if (m.rawInputValue !== inputValue) {
                m.reset();
                m.append(inputValue, {
                    raw: true
                });
            } else if (!isCurrent) m.remove(startInputPos);
            m.append(appended, masked.currentMaskFlags(flags));
            m.appendTail(tail);
            return {
                index: index,
                weight: m.rawInputValue.length,
                totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.displayValue.length, (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT)))
            };
        });
        // pop masks with longer values first
        inputs.sort((i1, i2)=>i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
        return masked.compiledMasks[inputs[0].index];
    }
};
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedDynamic = $7d499f714d762607$export$2e2bcd8739ae039;














/** Pattern which validates enum values */ class $dbfc6b8537866c86$export$2e2bcd8739ae039 extends (0, $a593d1cc05cf62bc$export$2e2bcd8739ae039) {
    constructor(opts){
        super(opts); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { enum: _enum, ...eopts } = opts;
        if (_enum) {
            const lengths = _enum.map((e)=>e.length);
            const requiredLength = Math.min(...lengths);
            const optionalLength = Math.max(...lengths) - requiredLength;
            eopts.mask = "*".repeat(requiredLength);
            if (optionalLength) eopts.mask += "[" + "*".repeat(optionalLength) + "]";
            this.enum = _enum;
        }
        super._update(eopts);
    }
    doValidate(flags) {
        return this.enum.some((e)=>e.indexOf(this.unmaskedValue) === 0) && super.doValidate(flags);
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedEnum = $dbfc6b8537866c86$export$2e2bcd8739ae039;








/** Masking by custom Function */ class $d12d3696a29f5a23$export$2e2bcd8739ae039 extends (0, $18a6c62942791a59$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update({
            ...opts,
            validate: opts.mask
        });
    }
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedFunction = $d12d3696a29f5a23$export$2e2bcd8739ae039;







/** Number mask */ class $8a2fcbb913c2ebd8$export$2e2bcd8739ae039 extends (0, $18a6c62942791a59$export$2e2bcd8739ae039) {
    /** Single char */ /** Single char */ /** Array of single chars */ /** */ /** */ /** Digits after point */ /** Flag to remove leading and trailing zeros in the end of editing */ /** Flag to pad trailing zeros after point in the end of editing */ /** Enable characters overwriting */ /** */ /** */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super({
            ...$8a2fcbb913c2ebd8$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        this._updateRegExps();
    }
    _updateRegExps() {
        const start = "^" + (this.allowNegative ? "[+|\\-]?" : "");
        const mid = "\\d*";
        const end = (this.scale ? "(" + (0, $b9f82b1f38a24931$export$7c57da42ce8e346f)(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
        this._numberRegExp = new RegExp(start + mid + end);
        this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map((0, $b9f82b1f38a24931$export$7c57da42ce8e346f)).join("") + "]", "g");
        this._thousandsSeparatorRegExp = new RegExp((0, $b9f82b1f38a24931$export$7c57da42ce8e346f)(this.thousandsSeparator), "g");
    }
    _removeThousandsSeparators(value) {
        return value.replace(this._thousandsSeparatorRegExp, "");
    }
    _insertThousandsSeparators(value) {
        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        const parts = value.split(this.radix);
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
        return parts.join(this.radix);
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        const [prepCh, details] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */ (flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch), flags);
        if (ch && !prepCh) details.skip = true;
        if (prepCh && !this.allowPositive && !this.value && prepCh !== "-") details.aggregate(this._appendChar("-"));
        return [
            prepCh,
            details
        ];
    }
    _separatorsCount(to, extendOnSeparators) {
        if (extendOnSeparators === void 0) extendOnSeparators = false;
        let count = 0;
        for(let pos = 0; pos < to; ++pos)if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
            ++count;
            if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
        return count;
    }
    _separatorsCountFromSlice(slice) {
        if (slice === void 0) slice = this._value;
        return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        if (!this.thousandsSeparator) return super._appendCharRaw(ch, flags);
        const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
        this._value = this._removeThousandsSeparators(this.value);
        const appendDetails = super._appendCharRaw(ch, flags);
        this._value = this._insertThousandsSeparators(this._value);
        const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
        appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
        appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
        return appendDetails;
    }
    _findSeparatorAround(pos) {
        if (this.thousandsSeparator) {
            const searchFrom = pos - this.thousandsSeparator.length + 1;
            const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
            if (separatorPos <= pos) return separatorPos;
        }
        return -1;
    }
    _adjustRangeWithSeparators(from, to) {
        const separatorAroundFromPos = this._findSeparatorAround(from);
        if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
        const separatorAroundToPos = this._findSeparatorAround(to);
        if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
        return [
            from,
            to
        ];
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        const valueBeforePos = this.value.slice(0, fromPos);
        const valueAfterPos = this.value.slice(toPos);
        const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
        this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
        return new (0, $bd3b02e030d373d5$export$2e2bcd8739ae039)({
            tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
        });
    }
    nearestInputPos(cursorPos, direction) {
        if (!this.thousandsSeparator) return cursorPos;
        switch(direction){
            case (0, $b9f82b1f38a24931$export$9106728c49045482).NONE:
            case (0, $b9f82b1f38a24931$export$9106728c49045482).LEFT:
            case (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT:
                {
                    const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
                    if (separatorAtLeftPos >= 0) {
                        const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
                        if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_LEFT) return separatorAtLeftPos;
                    }
                    break;
                }
            case (0, $b9f82b1f38a24931$export$9106728c49045482).RIGHT:
            case (0, $b9f82b1f38a24931$export$9106728c49045482).FORCE_RIGHT:
                {
                    const separatorAtRightPos = this._findSeparatorAround(cursorPos);
                    if (separatorAtRightPos >= 0) return separatorAtRightPos + this.thousandsSeparator.length;
                }
        }
        return cursorPos;
    }
    doValidate(flags) {
        // validate as string
        let valid = Boolean(this._removeThousandsSeparators(this.value).match(this._numberRegExp));
        if (valid) {
            // validate as number
            const number = this.number;
            valid = valid && !isNaN(number) && // check min bound for negative values
            (this.min == null || this.min >= 0 || this.min <= this.number) && // check max bound for positive values
            (this.max == null || this.max <= 0 || this.number <= this.max);
        }
        return valid && super.doValidate(flags);
    }
    doCommit() {
        if (this.value) {
            const number = this.number;
            let validnum = number;
            // check bounds
            if (this.min != null) validnum = Math.max(validnum, this.min);
            if (this.max != null) validnum = Math.min(validnum, this.max);
            if (validnum !== number) this.unmaskedValue = this.format(validnum, this);
            let formatted = this.value;
            if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
            if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
            this._value = formatted;
        }
        super.doCommit();
    }
    _normalizeZeros(value) {
        const parts = this._removeThousandsSeparators(value).split(this.radix);
        // remove leading zeros
        parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num)=>sign + num);
        // add leading zero
        if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + "0";
        if (parts.length > 1) {
            parts[1] = parts[1].replace(/0*$/, ""); // remove trailing zeros
            if (!parts[1].length) parts.length = 1; // remove fractional
        }
        return this._insertThousandsSeparators(parts.join(this.radix));
    }
    _padFractionalZeros(value) {
        if (!value) return value;
        const parts = value.split(this.radix);
        if (parts.length < 2) parts.push("");
        parts[1] = parts[1].padEnd(this.scale, "0");
        return parts.join(this.radix);
    }
    doSkipInvalid(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === $8a2fcbb913c2ebd8$export$2e2bcd8739ae039.UNMASKED_RADIX || this.mapToRadix.includes(ch));
        return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
    }
    get unmaskedValue() {
        return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, $8a2fcbb913c2ebd8$export$2e2bcd8739ae039.UNMASKED_RADIX);
    }
    set unmaskedValue(unmaskedValue) {
        super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.parse(this.unmaskedValue, this);
    }
    set typedValue(n) {
        this.rawInputValue = this.format(n, this).replace($8a2fcbb913c2ebd8$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
    }
    /** Parsed Number */ get number() {
        return this.typedValue;
    }
    set number(number) {
        this.typedValue = number;
    }
    /**
    Is negative allowed
  */ get allowNegative() {
        return this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    /**
    Is positive allowed
  */ get allowPositive() {
        return this.min != null && this.min > 0 || this.max != null && this.max > 0;
    }
    typedValueEquals(value) {
        // handle  0 -> '' case (typed = 0 even if value = '')
        // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
        return (super.typedValueEquals(value) || $8a2fcbb913c2ebd8$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $8a2fcbb913c2ebd8$export$2e2bcd8739ae039.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === "");
    }
}
$8a2fcbb913c2ebd8$export$2e2bcd8739ae039.UNMASKED_RADIX = ".";
$8a2fcbb913c2ebd8$export$2e2bcd8739ae039.EMPTY_VALUES = [
    ...(0, $18a6c62942791a59$export$2e2bcd8739ae039).EMPTY_VALUES,
    0
];
$8a2fcbb913c2ebd8$export$2e2bcd8739ae039.DEFAULTS = {
    mask: Number,
    radix: ",",
    thousandsSeparator: "",
    mapToRadix: [
        $8a2fcbb913c2ebd8$export$2e2bcd8739ae039.UNMASKED_RADIX
    ],
    min: Number.MIN_SAFE_INTEGER,
    max: Number.MAX_SAFE_INTEGER,
    scale: 2,
    normalizeZeros: true,
    padFractionalZeros: false,
    parse: Number,
    format: (n)=>n.toLocaleString("en-US", {
            useGrouping: false,
            maximumFractionDigits: 20
        })
};
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).MaskedNumber = $8a2fcbb913c2ebd8$export$2e2bcd8739ae039;









/** Mask pipe source and destination types */ const $e50cd5fa4d277691$export$90dab59c3d4b6e03 = {
    MASKED: "value",
    UNMASKED: "unmaskedValue",
    TYPED: "typedValue"
};
/** Creates new pipe function depending on mask type, source and destination options */ function $e50cd5fa4d277691$export$a504d53a5b99e1b9(arg, from, to) {
    if (from === void 0) from = $e50cd5fa4d277691$export$90dab59c3d4b6e03.MASKED;
    if (to === void 0) to = $e50cd5fa4d277691$export$90dab59c3d4b6e03.MASKED;
    const masked = (0, $9b2a7934382d129f$export$2e2bcd8739ae039)(arg);
    return (value)=>masked.runIsolated((m)=>{
            m[from] = value;
            return m[to];
        });
}
/** Pipes value through mask depending on mask type, source and destination options */ function $e50cd5fa4d277691$export$a4627e546088548d(value, mask, from, to) {
    return $e50cd5fa4d277691$export$a504d53a5b99e1b9(mask, from, to)(value);
}
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).PIPE_TYPE = $e50cd5fa4d277691$export$90dab59c3d4b6e03;
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).createPipe = $e50cd5fa4d277691$export$a504d53a5b99e1b9;
(0, $7f8f9e4cb1731024$export$2e2bcd8739ae039).pipe = $e50cd5fa4d277691$export$a4627e546088548d;







try {
    globalThis.IMask = (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039);
} catch  {}


function $2cd9b892908a0c8c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2cd9b892908a0c8c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2cd9b892908a0c8c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2cd9b892908a0c8c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $2cd9b892908a0c8c$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $2cd9b892908a0c8c$var$CREATED = 1;
var $2cd9b892908a0c8c$var$MOUNTED = 2;
var $2cd9b892908a0c8c$var$IDLE = 3;
var $2cd9b892908a0c8c$var$MOVING = 4;
var $2cd9b892908a0c8c$var$SCROLLING = 5;
var $2cd9b892908a0c8c$var$DRAGGING = 6;
var $2cd9b892908a0c8c$var$DESTROYED = 7;
var $2cd9b892908a0c8c$var$STATES = {
    CREATED: $2cd9b892908a0c8c$var$CREATED,
    MOUNTED: $2cd9b892908a0c8c$var$MOUNTED,
    IDLE: $2cd9b892908a0c8c$var$IDLE,
    MOVING: $2cd9b892908a0c8c$var$MOVING,
    SCROLLING: $2cd9b892908a0c8c$var$SCROLLING,
    DRAGGING: $2cd9b892908a0c8c$var$DRAGGING,
    DESTROYED: $2cd9b892908a0c8c$var$DESTROYED
};
function $2cd9b892908a0c8c$var$empty(array) {
    array.length = 0;
}
function $2cd9b892908a0c8c$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $2cd9b892908a0c8c$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($2cd9b892908a0c8c$var$slice(arguments, 1)));
}
var $2cd9b892908a0c8c$var$nextTick = setTimeout;
var $2cd9b892908a0c8c$var$noop = function noop() {};
function $2cd9b892908a0c8c$var$raf(func) {
    return requestAnimationFrame(func);
}
function $2cd9b892908a0c8c$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $2cd9b892908a0c8c$var$isObject(subject) {
    return !$2cd9b892908a0c8c$var$isNull(subject) && $2cd9b892908a0c8c$var$typeOf("object", subject);
}
var $2cd9b892908a0c8c$var$isArray = Array.isArray;
var $2cd9b892908a0c8c$var$isFunction = $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$typeOf, "function");
var $2cd9b892908a0c8c$var$isString = $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$typeOf, "string");
var $2cd9b892908a0c8c$var$isUndefined = $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$typeOf, "undefined");
function $2cd9b892908a0c8c$var$isNull(subject) {
    return subject === null;
}
function $2cd9b892908a0c8c$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $2cd9b892908a0c8c$var$toArray(value) {
    return $2cd9b892908a0c8c$var$isArray(value) ? value : [
        value
    ];
}
function $2cd9b892908a0c8c$var$forEach(values, iteratee) {
    $2cd9b892908a0c8c$var$toArray(values).forEach(iteratee);
}
function $2cd9b892908a0c8c$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $2cd9b892908a0c8c$var$push(array, items) {
    array.push.apply(array, $2cd9b892908a0c8c$var$toArray(items));
    return array;
}
function $2cd9b892908a0c8c$var$toggleClass(elm, classes, add) {
    if (elm) $2cd9b892908a0c8c$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $2cd9b892908a0c8c$var$addClass(elm, classes) {
    $2cd9b892908a0c8c$var$toggleClass(elm, $2cd9b892908a0c8c$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $2cd9b892908a0c8c$var$append(parent, children) {
    $2cd9b892908a0c8c$var$forEach(children, parent.appendChild.bind(parent));
}
function $2cd9b892908a0c8c$var$before(nodes, ref) {
    $2cd9b892908a0c8c$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $2cd9b892908a0c8c$var$matches(elm, selector) {
    return $2cd9b892908a0c8c$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $2cd9b892908a0c8c$var$children(parent, selector) {
    var children2 = parent ? $2cd9b892908a0c8c$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $2cd9b892908a0c8c$var$matches(child, selector);
    }) : children2;
}
function $2cd9b892908a0c8c$var$child(parent, selector) {
    return selector ? $2cd9b892908a0c8c$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $2cd9b892908a0c8c$var$ownKeys = Object.keys;
function $2cd9b892908a0c8c$var$forOwn(object, iteratee, right) {
    if (object) (right ? $2cd9b892908a0c8c$var$ownKeys(object).reverse() : $2cd9b892908a0c8c$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $2cd9b892908a0c8c$var$assign(object) {
    $2cd9b892908a0c8c$var$slice(arguments, 1).forEach(function(source) {
        $2cd9b892908a0c8c$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $2cd9b892908a0c8c$var$merge(object) {
    $2cd9b892908a0c8c$var$slice(arguments, 1).forEach(function(source) {
        $2cd9b892908a0c8c$var$forOwn(source, function(value, key) {
            if ($2cd9b892908a0c8c$var$isArray(value)) object[key] = value.slice();
            else if ($2cd9b892908a0c8c$var$isObject(value)) object[key] = $2cd9b892908a0c8c$var$merge({}, $2cd9b892908a0c8c$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $2cd9b892908a0c8c$var$omit(object, keys) {
    $2cd9b892908a0c8c$var$forEach(keys || $2cd9b892908a0c8c$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $2cd9b892908a0c8c$var$removeAttribute(elms, attrs) {
    $2cd9b892908a0c8c$var$forEach(elms, function(elm) {
        $2cd9b892908a0c8c$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $2cd9b892908a0c8c$var$setAttribute(elms, attrs, value) {
    if ($2cd9b892908a0c8c$var$isObject(attrs)) $2cd9b892908a0c8c$var$forOwn(attrs, function(value2, name) {
        $2cd9b892908a0c8c$var$setAttribute(elms, name, value2);
    });
    else $2cd9b892908a0c8c$var$forEach(elms, function(elm) {
        $2cd9b892908a0c8c$var$isNull(value) || value === "" ? $2cd9b892908a0c8c$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $2cd9b892908a0c8c$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $2cd9b892908a0c8c$var$isString(attrs) ? $2cd9b892908a0c8c$var$addClass(elm, attrs) : $2cd9b892908a0c8c$var$setAttribute(elm, attrs);
    parent && $2cd9b892908a0c8c$var$append(parent, elm);
    return elm;
}
function $2cd9b892908a0c8c$var$style(elm, prop, value) {
    if ($2cd9b892908a0c8c$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$2cd9b892908a0c8c$var$isNull(value)) elm.style[prop] = "" + value;
}
function $2cd9b892908a0c8c$var$display(elm, display2) {
    $2cd9b892908a0c8c$var$style(elm, "display", display2);
}
function $2cd9b892908a0c8c$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $2cd9b892908a0c8c$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $2cd9b892908a0c8c$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $2cd9b892908a0c8c$var$rect(target) {
    return target.getBoundingClientRect();
}
function $2cd9b892908a0c8c$var$remove(nodes) {
    $2cd9b892908a0c8c$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $2cd9b892908a0c8c$var$parseHtml(html) {
    return $2cd9b892908a0c8c$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $2cd9b892908a0c8c$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $2cd9b892908a0c8c$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $2cd9b892908a0c8c$var$queryAll(parent, selector) {
    return selector ? $2cd9b892908a0c8c$var$slice(parent.querySelectorAll(selector)) : [];
}
function $2cd9b892908a0c8c$var$removeClass(elm, classes) {
    $2cd9b892908a0c8c$var$toggleClass(elm, classes, false);
}
function $2cd9b892908a0c8c$var$timeOf(e) {
    return e.timeStamp;
}
function $2cd9b892908a0c8c$var$unit(value) {
    return $2cd9b892908a0c8c$var$isString(value) ? value : value ? value + "px" : "";
}
var $2cd9b892908a0c8c$var$PROJECT_CODE = "splide";
var $2cd9b892908a0c8c$var$DATA_ATTRIBUTE = "data-" + $2cd9b892908a0c8c$var$PROJECT_CODE;
function $2cd9b892908a0c8c$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $2cd9b892908a0c8c$var$PROJECT_CODE + "] " + (message || ""));
}
var $2cd9b892908a0c8c$var$min = Math.min, $2cd9b892908a0c8c$var$max = Math.max, $2cd9b892908a0c8c$var$floor = Math.floor, $2cd9b892908a0c8c$var$ceil = Math.ceil, $2cd9b892908a0c8c$var$abs = Math.abs;
function $2cd9b892908a0c8c$var$approximatelyEqual(x, y, epsilon) {
    return $2cd9b892908a0c8c$var$abs(x - y) < epsilon;
}
function $2cd9b892908a0c8c$var$between(number, x, y, exclusive) {
    var minimum = $2cd9b892908a0c8c$var$min(x, y);
    var maximum = $2cd9b892908a0c8c$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $2cd9b892908a0c8c$var$clamp(number, x, y) {
    var minimum = $2cd9b892908a0c8c$var$min(x, y);
    var maximum = $2cd9b892908a0c8c$var$max(x, y);
    return $2cd9b892908a0c8c$var$min($2cd9b892908a0c8c$var$max(minimum, number), maximum);
}
function $2cd9b892908a0c8c$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $2cd9b892908a0c8c$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $2cd9b892908a0c8c$var$format(string, replacements) {
    $2cd9b892908a0c8c$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $2cd9b892908a0c8c$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $2cd9b892908a0c8c$var$ids = {};
function $2cd9b892908a0c8c$var$uniqueId(prefix) {
    return "" + prefix + $2cd9b892908a0c8c$var$pad($2cd9b892908a0c8c$var$ids[prefix] = ($2cd9b892908a0c8c$var$ids[prefix] || 0) + 1);
}
function $2cd9b892908a0c8c$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $2cd9b892908a0c8c$var$forEach(targets, function(target) {
            target && $2cd9b892908a0c8c$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $2cd9b892908a0c8c$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $2cd9b892908a0c8c$export$d300dc1a2634364b = "mounted";
var $2cd9b892908a0c8c$export$d8dac49b4532735a = "ready";
var $2cd9b892908a0c8c$export$2aa493d7c3275167 = "move";
var $2cd9b892908a0c8c$export$fe5802204b967f0d = "moved";
var $2cd9b892908a0c8c$export$5adb665701eda1ce = "click";
var $2cd9b892908a0c8c$export$92e3eae133acac4c = "active";
var $2cd9b892908a0c8c$export$6bcbb81035c12cea = "inactive";
var $2cd9b892908a0c8c$export$6a5b3445e4066a53 = "visible";
var $2cd9b892908a0c8c$export$8c5c7a21d54563e9 = "hidden";
var $2cd9b892908a0c8c$export$7f4701ac5e05e39f = "refresh";
var $2cd9b892908a0c8c$export$db40ab7c0855fa5c = "updated";
var $2cd9b892908a0c8c$export$7e019dae5103a285 = "resize";
var $2cd9b892908a0c8c$export$d637eba1e9e28482 = "resized";
var $2cd9b892908a0c8c$export$e84bf5065c9087ac = "drag";
var $2cd9b892908a0c8c$export$8e9f636d2c722196 = "dragging";
var $2cd9b892908a0c8c$export$90ea576bd3fdeb60 = "dragged";
var $2cd9b892908a0c8c$export$49801896908b5e33 = "scroll";
var $2cd9b892908a0c8c$export$ff8164bff3202b9 = "scrolled";
var $2cd9b892908a0c8c$export$6cbac5b662a31e1b = "overflow";
var $2cd9b892908a0c8c$export$88c4cf7419e470cd = "destroy";
var $2cd9b892908a0c8c$export$8647f6b043e04e9d = "arrows:mounted";
var $2cd9b892908a0c8c$export$d467f9343b961f75 = "arrows:updated";
var $2cd9b892908a0c8c$export$bf89a4e4349c9778 = "pagination:mounted";
var $2cd9b892908a0c8c$export$eb2019082ed6de0b = "pagination:updated";
var $2cd9b892908a0c8c$export$84015c33508f94ec = "navigation:mounted";
var $2cd9b892908a0c8c$export$23663268a31b79e2 = "autoplay:play";
var $2cd9b892908a0c8c$export$185723258309b608 = "autoplay:playing";
var $2cd9b892908a0c8c$export$16a1e4f3d0368265 = "autoplay:pause";
var $2cd9b892908a0c8c$export$9f64346e17f0ec8e = "lazyload:loaded";
var $2cd9b892908a0c8c$export$6d5af59619d10e6a = "sk";
var $2cd9b892908a0c8c$export$f0af896383d5adff = "sh";
var $2cd9b892908a0c8c$export$28dea85f216954dc = "ei";
function $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $2cd9b892908a0c8c$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $2cd9b892908a0c8c$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $2cd9b892908a0c8c$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $2cd9b892908a0c8c$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($2cd9b892908a0c8c$export$88c4cf7419e470cd, binder.destroy);
    return $2cd9b892908a0c8c$var$assign(binder, {
        bus: bus,
        on: on,
        off: $2cd9b892908a0c8c$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $2cd9b892908a0c8c$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $2cd9b892908a0c8c$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $2cd9b892908a0c8c$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $2cd9b892908a0c8c$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $2cd9b892908a0c8c$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $2cd9b892908a0c8c$var$includes($2cd9b892908a0c8c$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $2cd9b892908a0c8c$export$efff0f5979573c99(func, duration) {
    var interval = $2cd9b892908a0c8c$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $2cd9b892908a0c8c$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $2cd9b892908a0c8c$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $2cd9b892908a0c8c$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $2cd9b892908a0c8c$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($2cd9b892908a0c8c$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $2cd9b892908a0c8c$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $2cd9b892908a0c8c$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($2cd9b892908a0c8c$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $2cd9b892908a0c8c$var$merge(options, reducedMotion) : $2cd9b892908a0c8c$var$omit(options, $2cd9b892908a0c8c$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $2cd9b892908a0c8c$var$merge(options, opts);
        base && $2cd9b892908a0c8c$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($2cd9b892908a0c8c$var$CREATED)) Splide2.emit($2cd9b892908a0c8c$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $2cd9b892908a0c8c$var$ARROW = "Arrow";
var $2cd9b892908a0c8c$var$ARROW_LEFT = $2cd9b892908a0c8c$var$ARROW + "Left";
var $2cd9b892908a0c8c$var$ARROW_RIGHT = $2cd9b892908a0c8c$var$ARROW + "Right";
var $2cd9b892908a0c8c$var$ARROW_UP = $2cd9b892908a0c8c$var$ARROW + "Up";
var $2cd9b892908a0c8c$var$ARROW_DOWN = $2cd9b892908a0c8c$var$ARROW + "Down";
var $2cd9b892908a0c8c$export$373e92e0788ff06e = "ltr";
var $2cd9b892908a0c8c$export$850f7749a2909601 = "rtl";
var $2cd9b892908a0c8c$export$97170d9824b89709 = "ttb";
var $2cd9b892908a0c8c$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $2cd9b892908a0c8c$var$ARROW_UP,
        $2cd9b892908a0c8c$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $2cd9b892908a0c8c$var$ARROW_DOWN,
        $2cd9b892908a0c8c$var$ARROW_LEFT
    ]
};
function $2cd9b892908a0c8c$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $2cd9b892908a0c8c$export$850f7749a2909601 && !axisOnly ? 1 : direction === $2cd9b892908a0c8c$export$97170d9824b89709 ? 0 : -1;
        return $2cd9b892908a0c8c$var$ORIENTATION_MAP[prop] && $2cd9b892908a0c8c$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $2cd9b892908a0c8c$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $2cd9b892908a0c8c$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $2cd9b892908a0c8c$var$ROLE = "role";
var $2cd9b892908a0c8c$var$TAB_INDEX = "tabindex";
var $2cd9b892908a0c8c$var$DISABLED = "disabled";
var $2cd9b892908a0c8c$var$ARIA_PREFIX = "aria-";
var $2cd9b892908a0c8c$var$ARIA_CONTROLS = $2cd9b892908a0c8c$var$ARIA_PREFIX + "controls";
var $2cd9b892908a0c8c$var$ARIA_CURRENT = $2cd9b892908a0c8c$var$ARIA_PREFIX + "current";
var $2cd9b892908a0c8c$var$ARIA_SELECTED = $2cd9b892908a0c8c$var$ARIA_PREFIX + "selected";
var $2cd9b892908a0c8c$var$ARIA_LABEL = $2cd9b892908a0c8c$var$ARIA_PREFIX + "label";
var $2cd9b892908a0c8c$var$ARIA_LABELLEDBY = $2cd9b892908a0c8c$var$ARIA_PREFIX + "labelledby";
var $2cd9b892908a0c8c$var$ARIA_HIDDEN = $2cd9b892908a0c8c$var$ARIA_PREFIX + "hidden";
var $2cd9b892908a0c8c$var$ARIA_ORIENTATION = $2cd9b892908a0c8c$var$ARIA_PREFIX + "orientation";
var $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION = $2cd9b892908a0c8c$var$ARIA_PREFIX + "roledescription";
var $2cd9b892908a0c8c$var$ARIA_LIVE = $2cd9b892908a0c8c$var$ARIA_PREFIX + "live";
var $2cd9b892908a0c8c$var$ARIA_BUSY = $2cd9b892908a0c8c$var$ARIA_PREFIX + "busy";
var $2cd9b892908a0c8c$var$ARIA_ATOMIC = $2cd9b892908a0c8c$var$ARIA_PREFIX + "atomic";
var $2cd9b892908a0c8c$var$ALL_ATTRIBUTES = [
    $2cd9b892908a0c8c$var$ROLE,
    $2cd9b892908a0c8c$var$TAB_INDEX,
    $2cd9b892908a0c8c$var$DISABLED,
    $2cd9b892908a0c8c$var$ARIA_CONTROLS,
    $2cd9b892908a0c8c$var$ARIA_CURRENT,
    $2cd9b892908a0c8c$var$ARIA_LABEL,
    $2cd9b892908a0c8c$var$ARIA_LABELLEDBY,
    $2cd9b892908a0c8c$var$ARIA_HIDDEN,
    $2cd9b892908a0c8c$var$ARIA_ORIENTATION,
    $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION
];
var $2cd9b892908a0c8c$var$CLASS_PREFIX = $2cd9b892908a0c8c$var$PROJECT_CODE + "__";
var $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX = "is-";
var $2cd9b892908a0c8c$export$93b21159ad85c843 = $2cd9b892908a0c8c$var$PROJECT_CODE;
var $2cd9b892908a0c8c$export$7738b09ac0a98952 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "track";
var $2cd9b892908a0c8c$export$19cc2a5451235cae = $2cd9b892908a0c8c$var$CLASS_PREFIX + "list";
var $2cd9b892908a0c8c$export$8d922915837a38d3 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "slide";
var $2cd9b892908a0c8c$export$2c1ba4a4f1aa4947 = $2cd9b892908a0c8c$export$8d922915837a38d3 + "--clone";
var $2cd9b892908a0c8c$export$e9ba7e444ba60a12 = $2cd9b892908a0c8c$export$8d922915837a38d3 + "__container";
var $2cd9b892908a0c8c$export$a26cbd955fecf11e = $2cd9b892908a0c8c$var$CLASS_PREFIX + "arrows";
var $2cd9b892908a0c8c$export$516e7d18e13a2dca = $2cd9b892908a0c8c$var$CLASS_PREFIX + "arrow";
var $2cd9b892908a0c8c$export$58ea3db24c33b76 = $2cd9b892908a0c8c$export$516e7d18e13a2dca + "--prev";
var $2cd9b892908a0c8c$export$4885afd7098a65c2 = $2cd9b892908a0c8c$export$516e7d18e13a2dca + "--next";
var $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "pagination";
var $2cd9b892908a0c8c$export$52f2cca6a5eee805 = $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3 + "__page";
var $2cd9b892908a0c8c$export$4c82dc32b1c4ace5 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "progress";
var $2cd9b892908a0c8c$export$2c9b091c749f4409 = $2cd9b892908a0c8c$export$4c82dc32b1c4ace5 + "__bar";
var $2cd9b892908a0c8c$export$a29701deef84b825 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "toggle";
var $2cd9b892908a0c8c$export$d9d247d51b430dbb = $2cd9b892908a0c8c$export$a29701deef84b825 + "__play";
var $2cd9b892908a0c8c$export$3529f201a419925b = $2cd9b892908a0c8c$export$a29701deef84b825 + "__pause";
var $2cd9b892908a0c8c$export$3e5381ee3fab8374 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "spinner";
var $2cd9b892908a0c8c$export$bb78d7c200da8960 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "sr";
var $2cd9b892908a0c8c$export$7761661e2d5b9388 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "initialized";
var $2cd9b892908a0c8c$export$72d36ecf3758cb4b = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "active";
var $2cd9b892908a0c8c$export$e423ac4972f5e196 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "prev";
var $2cd9b892908a0c8c$export$457a2d20827a2779 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "next";
var $2cd9b892908a0c8c$export$53ca4621bbab9a = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "visible";
var $2cd9b892908a0c8c$export$d22ec4ccb7996ba2 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "loading";
var $2cd9b892908a0c8c$export$b6f202a162a09100 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "focus-in";
var $2cd9b892908a0c8c$export$cd908cd1dd625e29 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "overflow";
var $2cd9b892908a0c8c$export$49f9eaea10ebf193 = [
    $2cd9b892908a0c8c$export$72d36ecf3758cb4b,
    $2cd9b892908a0c8c$export$53ca4621bbab9a,
    $2cd9b892908a0c8c$export$e423ac4972f5e196,
    $2cd9b892908a0c8c$export$457a2d20827a2779,
    $2cd9b892908a0c8c$export$d22ec4ccb7996ba2,
    $2cd9b892908a0c8c$export$b6f202a162a09100,
    $2cd9b892908a0c8c$export$cd908cd1dd625e29
];
var $2cd9b892908a0c8c$export$ba41d43e4a419565 = {
    slide: $2cd9b892908a0c8c$export$8d922915837a38d3,
    clone: $2cd9b892908a0c8c$export$2c1ba4a4f1aa4947,
    arrows: $2cd9b892908a0c8c$export$a26cbd955fecf11e,
    arrow: $2cd9b892908a0c8c$export$516e7d18e13a2dca,
    prev: $2cd9b892908a0c8c$export$58ea3db24c33b76,
    next: $2cd9b892908a0c8c$export$4885afd7098a65c2,
    pagination: $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3,
    page: $2cd9b892908a0c8c$export$52f2cca6a5eee805,
    spinner: $2cd9b892908a0c8c$export$3e5381ee3fab8374
};
function $2cd9b892908a0c8c$var$closest(from, selector) {
    if ($2cd9b892908a0c8c$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($2cd9b892908a0c8c$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $2cd9b892908a0c8c$var$FRICTION = 5;
var $2cd9b892908a0c8c$var$LOG_INTERVAL = 200;
var $2cd9b892908a0c8c$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $2cd9b892908a0c8c$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $2cd9b892908a0c8c$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $2cd9b892908a0c8c$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, destroy);
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, setup);
        on($2cd9b892908a0c8c$export$db40ab7c0855fa5c, update);
        bind(document, $2cd9b892908a0c8c$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $2cd9b892908a0c8c$var$toggleClass(root, $2cd9b892908a0c8c$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $2cd9b892908a0c8c$var$ALL_ATTRIBUTES.concat("style");
        $2cd9b892908a0c8c$var$empty(slides);
        $2cd9b892908a0c8c$var$removeClass(root, rootClasses);
        $2cd9b892908a0c8c$var$removeClass(track, trackClasses);
        $2cd9b892908a0c8c$var$removeAttribute([
            track,
            list
        ], attrs);
        $2cd9b892908a0c8c$var$removeAttribute(root, completely ? attrs : [
            "style",
            $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $2cd9b892908a0c8c$var$removeClass(root, rootClasses);
        $2cd9b892908a0c8c$var$removeClass(track, trackClasses);
        rootClasses = getClasses($2cd9b892908a0c8c$export$93b21159ad85c843);
        trackClasses = getClasses($2cd9b892908a0c8c$export$7738b09ac0a98952);
        $2cd9b892908a0c8c$var$addClass(root, rootClasses);
        $2cd9b892908a0c8c$var$addClass(track, trackClasses);
        $2cd9b892908a0c8c$var$setAttribute(root, $2cd9b892908a0c8c$var$ARIA_LABEL, options.label);
        $2cd9b892908a0c8c$var$setAttribute(root, $2cd9b892908a0c8c$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $2cd9b892908a0c8c$export$7738b09ac0a98952);
        list = $2cd9b892908a0c8c$var$child(track, "." + $2cd9b892908a0c8c$export$19cc2a5451235cae);
        $2cd9b892908a0c8c$var$assert(track && list, "A track/list element is missing.");
        $2cd9b892908a0c8c$var$push(slides, $2cd9b892908a0c8c$var$children(list, "." + $2cd9b892908a0c8c$export$8d922915837a38d3 + ":not(." + $2cd9b892908a0c8c$export$2c1ba4a4f1aa4947 + ")"));
        $2cd9b892908a0c8c$var$forOwn({
            arrows: $2cd9b892908a0c8c$export$a26cbd955fecf11e,
            pagination: $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3,
            prev: $2cd9b892908a0c8c$export$58ea3db24c33b76,
            next: $2cd9b892908a0c8c$export$4885afd7098a65c2,
            bar: $2cd9b892908a0c8c$export$2c9b091c749f4409,
            toggle: $2cd9b892908a0c8c$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $2cd9b892908a0c8c$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $2cd9b892908a0c8c$var$uniqueId($2cd9b892908a0c8c$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$2cd9b892908a0c8c$var$getAttribute(root, $2cd9b892908a0c8c$var$ROLE) && root.tagName !== "SECTION" && role) $2cd9b892908a0c8c$var$setAttribute(root, $2cd9b892908a0c8c$var$ROLE, role);
        $2cd9b892908a0c8c$var$setAttribute(root, $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $2cd9b892908a0c8c$var$setAttribute(list, $2cd9b892908a0c8c$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $2cd9b892908a0c8c$var$query(root, selector);
        return elm && $2cd9b892908a0c8c$var$closest(elm, "." + $2cd9b892908a0c8c$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $2cd9b892908a0c8c$export$93b21159ad85c843 && $2cd9b892908a0c8c$export$72d36ecf3758cb4b
        ];
    }
    return $2cd9b892908a0c8c$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $2cd9b892908a0c8c$export$e5a58a5ee5b54c22 = "slide";
var $2cd9b892908a0c8c$export$f42383286ed1223d = "loop";
var $2cd9b892908a0c8c$export$742b62a5690c060 = "fade";
function $2cd9b892908a0c8c$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $2cd9b892908a0c8c$var$getAttribute(slide, "style");
    var label = $2cd9b892908a0c8c$var$getAttribute(slide, $2cd9b892908a0c8c$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $2cd9b892908a0c8c$var$child(slide, "." + $2cd9b892908a0c8c$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $2cd9b892908a0c8c$var$pad(index + 1);
            $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ROLE, pagination ? "tabpanel" : "group");
            $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_LABEL, label || $2cd9b892908a0c8c$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $2cd9b892908a0c8c$var$apply(emit, $2cd9b892908a0c8c$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $2cd9b892908a0c8c$var$apply(emit, $2cd9b892908a0c8c$export$6d5af59619d10e6a, self));
        on([
            $2cd9b892908a0c8c$export$fe5802204b967f0d,
            $2cd9b892908a0c8c$export$f0af896383d5adff,
            $2cd9b892908a0c8c$export$ff8164bff3202b9
        ], update);
        on($2cd9b892908a0c8c$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($2cd9b892908a0c8c$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $2cd9b892908a0c8c$var$removeClass(slide, $2cd9b892908a0c8c$export$49f9eaea10ebf193);
        $2cd9b892908a0c8c$var$removeAttribute(slide, $2cd9b892908a0c8c$var$ALL_ATTRIBUTES);
        $2cd9b892908a0c8c$var$setAttribute(slide, "style", styles);
        $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_LABEL, $2cd9b892908a0c8c$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_CONTROLS, controls);
        $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $2cd9b892908a0c8c$var$removeAttribute(slide, $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $2cd9b892908a0c8c$var$toggleClass(slide, $2cd9b892908a0c8c$export$e423ac4972f5e196, index === curr - 1);
            $2cd9b892908a0c8c$var$toggleClass(slide, $2cd9b892908a0c8c$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $2cd9b892908a0c8c$var$hasClass(slide, $2cd9b892908a0c8c$export$72d36ecf3758cb4b)) {
            $2cd9b892908a0c8c$var$toggleClass(slide, $2cd9b892908a0c8c$export$72d36ecf3758cb4b, active);
            $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $2cd9b892908a0c8c$export$92e3eae133acac4c : $2cd9b892908a0c8c$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $2cd9b892908a0c8c$var$MOVING,
            $2cd9b892908a0c8c$var$SCROLLING
        ])) $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_HIDDEN, hidden || "");
        $2cd9b892908a0c8c$var$setAttribute($2cd9b892908a0c8c$var$queryAll(slide, options.focusableNodes || ""), $2cd9b892908a0c8c$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $2cd9b892908a0c8c$var$hasClass(slide, $2cd9b892908a0c8c$export$53ca4621bbab9a)) {
            $2cd9b892908a0c8c$var$toggleClass(slide, $2cd9b892908a0c8c$export$53ca4621bbab9a, visible);
            emit(visible ? $2cd9b892908a0c8c$export$6a5b3445e4066a53 : $2cd9b892908a0c8c$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $2cd9b892908a0c8c$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $2cd9b892908a0c8c$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($2cd9b892908a0c8c$export$742b62a5690c060)) return isActive();
        var trackRect = $2cd9b892908a0c8c$var$rect(Components.Elements.track);
        var slideRect = $2cd9b892908a0c8c$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $2cd9b892908a0c8c$var$floor(trackRect[left]) <= $2cd9b892908a0c8c$var$ceil(slideRect[left]) && $2cd9b892908a0c8c$var$floor(slideRect[right]) <= $2cd9b892908a0c8c$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $2cd9b892908a0c8c$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d))) diff = $2cd9b892908a0c8c$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $2cd9b892908a0c8c$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, destroy);
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $2cd9b892908a0c8c$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $2cd9b892908a0c8c$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $2cd9b892908a0c8c$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $2cd9b892908a0c8c$var$forEach(items, function(slide) {
            if ($2cd9b892908a0c8c$var$isString(slide)) slide = $2cd9b892908a0c8c$var$parseHtml(slide);
            if ($2cd9b892908a0c8c$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $2cd9b892908a0c8c$var$before(slide, ref) : $2cd9b892908a0c8c$var$append(list, slide);
                $2cd9b892908a0c8c$var$addClass(slide, options.classes.slide);
                observeImages(slide, $2cd9b892908a0c8c$var$apply(emit, $2cd9b892908a0c8c$export$7e019dae5103a285));
            }
        });
        emit($2cd9b892908a0c8c$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $2cd9b892908a0c8c$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($2cd9b892908a0c8c$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($2cd9b892908a0c8c$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $2cd9b892908a0c8c$var$isString(matcher) ? $2cd9b892908a0c8c$var$matches(Slide2.slide, matcher) : $2cd9b892908a0c8c$var$includes($2cd9b892908a0c8c$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $2cd9b892908a0c8c$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $2cd9b892908a0c8c$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $2cd9b892908a0c8c$export$efff0f5979573c99($2cd9b892908a0c8c$var$apply(emit, $2cd9b892908a0c8c$export$7e019dae5103a285)));
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], init);
        on($2cd9b892908a0c8c$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $2cd9b892908a0c8c$export$97170d9824b89709;
        $2cd9b892908a0c8c$var$style(root, "maxWidth", $2cd9b892908a0c8c$var$unit(options.width));
        $2cd9b892908a0c8c$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $2cd9b892908a0c8c$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $2cd9b892908a0c8c$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $2cd9b892908a0c8c$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $2cd9b892908a0c8c$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($2cd9b892908a0c8c$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $2cd9b892908a0c8c$var$toggleClass(root, $2cd9b892908a0c8c$export$cd908cd1dd625e29, overflow);
                emit($2cd9b892908a0c8c$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $2cd9b892908a0c8c$var$unit(padding[prop] || ($2cd9b892908a0c8c$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $2cd9b892908a0c8c$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $2cd9b892908a0c8c$var$unit(options.height || $2cd9b892908a0c8c$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $2cd9b892908a0c8c$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $2cd9b892908a0c8c$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $2cd9b892908a0c8c$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $2cd9b892908a0c8c$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $2cd9b892908a0c8c$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $2cd9b892908a0c8c$var$rect(Slide.slide)[resolve("right")];
            var left = $2cd9b892908a0c8c$var$rect(list)[resolve("left")];
            return $2cd9b892908a0c8c$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($2cd9b892908a0c8c$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($2cd9b892908a0c8c$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($2cd9b892908a0c8c$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $2cd9b892908a0c8c$var$MULTIPLIER = 2;
function $2cd9b892908a0c8c$var$Clones(Splide2, Components2, options) {
    var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, remount);
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $2cd9b892908a0c8c$var$remove(clones);
        $2cd9b892908a0c8c$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($2cd9b892908a0c8c$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$2cd9b892908a0c8c$var$push(slides, slides);
            $2cd9b892908a0c8c$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $2cd9b892908a0c8c$var$before(clone, slides[0].slide) : $2cd9b892908a0c8c$var$append(Elements.list, clone);
                $2cd9b892908a0c8c$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $2cd9b892908a0c8c$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $2cd9b892908a0c8c$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d)) clones2 = 0;
        else if ($2cd9b892908a0c8c$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $2cd9b892908a0c8c$var$ceil($2cd9b892908a0c8c$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $2cd9b892908a0c8c$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $2cd9b892908a0c8c$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$d637eba1e9e28482,
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($2cd9b892908a0c8c$var$MOVING);
        emit($2cd9b892908a0c8c$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($2cd9b892908a0c8c$var$IDLE);
            emit($2cd9b892908a0c8c$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($2cd9b892908a0c8c$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $2cd9b892908a0c8c$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($2cd9b892908a0c8c$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($2cd9b892908a0c8c$var$ceil($2cd9b892908a0c8c$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $2cd9b892908a0c8c$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $2cd9b892908a0c8c$var$rect(list)[left] - $2cd9b892908a0c8c$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22)) position = $2cd9b892908a0c8c$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $2cd9b892908a0c8c$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $2cd9b892908a0c8c$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $2cd9b892908a0c8c$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d);
    var isSlide = Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22);
    var getNext = $2cd9b892908a0c8c$var$apply(getAdjacent, false);
    var getPrev = $2cd9b892908a0c8c$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f,
            $2cd9b892908a0c8c$export$28dea85f216954dc
        ], init);
        on($2cd9b892908a0c8c$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $2cd9b892908a0c8c$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($2cd9b892908a0c8c$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $2cd9b892908a0c8c$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($2cd9b892908a0c8c$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $2cd9b892908a0c8c$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$2cd9b892908a0c8c$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($2cd9b892908a0c8c$var$between(0, dest, from, true) || $2cd9b892908a0c8c$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $2cd9b892908a0c8c$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $2cd9b892908a0c8c$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $2cd9b892908a0c8c$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $2cd9b892908a0c8c$var$min(index, endIndex) : $2cd9b892908a0c8c$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $2cd9b892908a0c8c$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$2cd9b892908a0c8c$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $2cd9b892908a0c8c$var$MOVING,
            $2cd9b892908a0c8c$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $2cd9b892908a0c8c$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $2cd9b892908a0c8c$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $2cd9b892908a0c8c$var$SIZE = 40;
function $2cd9b892908a0c8c$var$Arrows(Splide2, Components2, options) {
    var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($2cd9b892908a0c8c$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $2cd9b892908a0c8c$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $2cd9b892908a0c8c$var$display(wrapper, enabled ? "" : "none");
            $2cd9b892908a0c8c$var$addClass(wrapper, wrapperClasses = $2cd9b892908a0c8c$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $2cd9b892908a0c8c$var$setAttribute([
                    prev,
                    next
                ], $2cd9b892908a0c8c$var$ARIA_CONTROLS, track.id);
                emit($2cd9b892908a0c8c$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $2cd9b892908a0c8c$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $2cd9b892908a0c8c$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $2cd9b892908a0c8c$var$removeAttribute([
            prev,
            next
        ], $2cd9b892908a0c8c$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$fe5802204b967f0d,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f,
            $2cd9b892908a0c8c$export$ff8164bff3202b9,
            $2cd9b892908a0c8c$export$28dea85f216954dc
        ], update);
        bind(next, "click", $2cd9b892908a0c8c$var$apply(go, ">"));
        bind(prev, "click", $2cd9b892908a0c8c$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $2cd9b892908a0c8c$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $2cd9b892908a0c8c$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $2cd9b892908a0c8c$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $2cd9b892908a0c8c$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $2cd9b892908a0c8c$var$SIZE + " " + $2cd9b892908a0c8c$var$SIZE + '" width="' + $2cd9b892908a0c8c$var$SIZE + '" height="' + $2cd9b892908a0c8c$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $2cd9b892908a0c8c$var$PATH) + '" />';
        return $2cd9b892908a0c8c$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $2cd9b892908a0c8c$var$setAttribute(prev, $2cd9b892908a0c8c$var$ARIA_LABEL, prevLabel);
            $2cd9b892908a0c8c$var$setAttribute(next, $2cd9b892908a0c8c$var$ARIA_LABEL, nextLabel);
            emit($2cd9b892908a0c8c$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $2cd9b892908a0c8c$var$INTERVAL_DATA_ATTRIBUTE = $2cd9b892908a0c8c$var$DATA_ATTRIBUTE + "-interval";
function $2cd9b892908a0c8c$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $2cd9b892908a0c8c$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $2cd9b892908a0c8c$var$setAttribute(toggle, $2cd9b892908a0c8c$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $2cd9b892908a0c8c$export$2aa493d7c3275167,
            $2cd9b892908a0c8c$export$49801896908b5e33,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($2cd9b892908a0c8c$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($2cd9b892908a0c8c$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($2cd9b892908a0c8c$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $2cd9b892908a0c8c$var$toggleClass(toggle, $2cd9b892908a0c8c$export$72d36ecf3758cb4b, !stopped);
            $2cd9b892908a0c8c$var$setAttribute(toggle, $2cd9b892908a0c8c$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $2cd9b892908a0c8c$var$style(bar, "width", rate * 100 + "%");
        emit($2cd9b892908a0c8c$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$2cd9b892908a0c8c$var$getAttribute(Slide.slide, $2cd9b892908a0c8c$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $2cd9b892908a0c8c$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($2cd9b892908a0c8c$export$9f64346e17f0ec8e, $2cd9b892908a0c8c$var$apply(toggle, true));
            on([
                $2cd9b892908a0c8c$export$d300dc1a2634364b,
                $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
                $2cd9b892908a0c8c$export$7f4701ac5e05e39f
            ], $2cd9b892908a0c8c$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $2cd9b892908a0c8c$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $2cd9b892908a0c8c$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $2cd9b892908a0c8c$var$apply(cover, false)
    };
}
var $2cd9b892908a0c8c$var$BOUNCE_DIFF_THRESHOLD = 10;
var $2cd9b892908a0c8c$var$BOUNCE_DURATION = 600;
var $2cd9b892908a0c8c$var$FRICTION_FACTOR = 0.6;
var $2cd9b892908a0c8c$var$BASE_VELOCITY = 1.5;
var $2cd9b892908a0c8c$var$MIN_DURATION = 800;
function $2cd9b892908a0c8c$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($2cd9b892908a0c8c$export$2aa493d7c3275167, clear);
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $2cd9b892908a0c8c$var$sign(destination) * size * $2cd9b892908a0c8c$var$floor($2cd9b892908a0c8c$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $2cd9b892908a0c8c$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $2cd9b892908a0c8c$var$max($2cd9b892908a0c8c$var$abs(destination - from) / $2cd9b892908a0c8c$var$BASE_VELOCITY, $2cd9b892908a0c8c$var$MIN_DURATION);
        callback = onScrolled;
        interval = $2cd9b892908a0c8c$export$46ad21b25b6dccf0(duration, onEnd, $2cd9b892908a0c8c$var$apply(update, from, destination, noConstrain), 1);
        set($2cd9b892908a0c8c$var$SCROLLING);
        emit($2cd9b892908a0c8c$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($2cd9b892908a0c8c$var$IDLE);
        callback && callback();
        emit($2cd9b892908a0c8c$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $2cd9b892908a0c8c$var$FRICTION_FACTOR;
            if ($2cd9b892908a0c8c$var$abs(diff) < $2cd9b892908a0c8c$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $2cd9b892908a0c8c$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $2cd9b892908a0c8c$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $2cd9b892908a0c8c$var$POINTER_MOVE_EVENTS, $2cd9b892908a0c8c$var$noop, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $2cd9b892908a0c8c$var$POINTER_UP_EVENTS, $2cd9b892908a0c8c$var$noop, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $2cd9b892908a0c8c$var$POINTER_DOWN_EVENTS, onPointerDown, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $2cd9b892908a0c8c$var$prevent);
        on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $2cd9b892908a0c8c$var$MOVING,
                        $2cd9b892908a0c8c$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $2cd9b892908a0c8c$var$POINTER_MOVE_EVENTS, onPointerMove, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $2cd9b892908a0c8c$var$POINTER_UP_EVENTS, onPointerUp, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $2cd9b892908a0c8c$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($2cd9b892908a0c8c$var$DRAGGING)) {
            state.set($2cd9b892908a0c8c$var$DRAGGING);
            emit($2cd9b892908a0c8c$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $2cd9b892908a0c8c$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($2cd9b892908a0c8c$export$8e9f636d2c722196);
                $2cd9b892908a0c8c$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $2cd9b892908a0c8c$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($2cd9b892908a0c8c$var$DRAGGING)) {
            state.set($2cd9b892908a0c8c$var$IDLE);
            emit($2cd9b892908a0c8c$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $2cd9b892908a0c8c$var$prevent(e);
        }
        unbind(target, $2cd9b892908a0c8c$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $2cd9b892908a0c8c$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $2cd9b892908a0c8c$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($2cd9b892908a0c8c$export$742b62a5690c060)) Controller.go(orient($2cd9b892908a0c8c$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $2cd9b892908a0c8c$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $2cd9b892908a0c8c$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $2cd9b892908a0c8c$var$abs(diffCoord(e)) > $2cd9b892908a0c8c$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $2cd9b892908a0c8c$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $2cd9b892908a0c8c$var$sign(velocity) * $2cd9b892908a0c8c$var$min($2cd9b892908a0c8c$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $2cd9b892908a0c8c$var$timeOf(e) - $2cd9b892908a0c8c$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22) ? $2cd9b892908a0c8c$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$2cd9b892908a0c8c$var$matches(target2, "." + $2cd9b892908a0c8c$export$52f2cca6a5eee805 + ", ." + $2cd9b892908a0c8c$export$516e7d18e13a2dca) && (!noDrag || !$2cd9b892908a0c8c$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $2cd9b892908a0c8c$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $2cd9b892908a0c8c$var$ARROW_RIGHT,
    Left: $2cd9b892908a0c8c$var$ARROW_LEFT,
    Up: $2cd9b892908a0c8c$var$ARROW_UP,
    Down: $2cd9b892908a0c8c$var$ARROW_DOWN
};
function $2cd9b892908a0c8c$var$normalizeKey(key) {
    key = $2cd9b892908a0c8c$var$isString(key) ? key : key.key;
    return $2cd9b892908a0c8c$var$NORMALIZATION_MAP[key] || key;
}
var $2cd9b892908a0c8c$var$KEYBOARD_EVENT = "keydown";
function $2cd9b892908a0c8c$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($2cd9b892908a0c8c$export$db40ab7c0855fa5c, destroy);
        on($2cd9b892908a0c8c$export$db40ab7c0855fa5c, init);
        on($2cd9b892908a0c8c$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $2cd9b892908a0c8c$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $2cd9b892908a0c8c$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $2cd9b892908a0c8c$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $2cd9b892908a0c8c$var$normalizeKey(e);
            if (key === resolve($2cd9b892908a0c8c$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($2cd9b892908a0c8c$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE = $2cd9b892908a0c8c$var$DATA_ATTRIBUTE + "-lazy";
var $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE = $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $2cd9b892908a0c8c$var$IMAGE_SELECTOR = "[" + $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE + "], [" + $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE + "]";
function $2cd9b892908a0c8c$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $2cd9b892908a0c8c$export$fe5802204b967f0d,
        $2cd9b892908a0c8c$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $2cd9b892908a0c8c$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $2cd9b892908a0c8c$var$queryAll(Slide.slide, $2cd9b892908a0c8c$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $2cd9b892908a0c8c$var$getAttribute(img, $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE);
                var srcset = $2cd9b892908a0c8c$var$getAttribute(img, $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $2cd9b892908a0c8c$var$child(parent, "." + className) || $2cd9b892908a0c8c$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $2cd9b892908a0c8c$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $2cd9b892908a0c8c$var$addClass(data[1].slide, $2cd9b892908a0c8c$export$d22ec4ccb7996ba2);
        bind(img, "load error", $2cd9b892908a0c8c$var$apply(onLoad, data));
        $2cd9b892908a0c8c$var$setAttribute(img, "src", $2cd9b892908a0c8c$var$getAttribute(img, $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE));
        $2cd9b892908a0c8c$var$setAttribute(img, "srcset", $2cd9b892908a0c8c$var$getAttribute(img, $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE));
        $2cd9b892908a0c8c$var$removeAttribute(img, $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE);
        $2cd9b892908a0c8c$var$removeAttribute(img, $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $2cd9b892908a0c8c$var$removeClass(Slide.slide, $2cd9b892908a0c8c$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $2cd9b892908a0c8c$var$remove(data[2]);
            $2cd9b892908a0c8c$var$display(img, "");
            emit($2cd9b892908a0c8c$export$9f64346e17f0ec8e, img, Slide);
            emit($2cd9b892908a0c8c$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$empty, entries),
        check: check
    };
}
function $2cd9b892908a0c8c$var$Pagination(Splide2, Components2, options) {
    var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f,
            $2cd9b892908a0c8c$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $2cd9b892908a0c8c$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $2cd9b892908a0c8c$export$2aa493d7c3275167,
                $2cd9b892908a0c8c$export$49801896908b5e33,
                $2cd9b892908a0c8c$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($2cd9b892908a0c8c$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $2cd9b892908a0c8c$var$remove(placeholder ? $2cd9b892908a0c8c$var$slice(list.children) : list);
            $2cd9b892908a0c8c$var$removeClass(list, paginationClasses);
            $2cd9b892908a0c8c$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $2cd9b892908a0c8c$var$ceil(length / perPage);
        list = placeholder || $2cd9b892908a0c8c$var$create("ul", classes.pagination, Elements.track.parentElement);
        $2cd9b892908a0c8c$var$addClass(list, paginationClasses = $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $2cd9b892908a0c8c$var$setAttribute(list, $2cd9b892908a0c8c$var$ROLE, "tablist");
        $2cd9b892908a0c8c$var$setAttribute(list, $2cd9b892908a0c8c$var$ARIA_LABEL, i18n.select);
        $2cd9b892908a0c8c$var$setAttribute(list, $2cd9b892908a0c8c$var$ARIA_ORIENTATION, getDirection() === $2cd9b892908a0c8c$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $2cd9b892908a0c8c$var$create("li", null, list);
            var button = $2cd9b892908a0c8c$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $2cd9b892908a0c8c$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $2cd9b892908a0c8c$var$apply(onKeydown, i));
            $2cd9b892908a0c8c$var$setAttribute(li, $2cd9b892908a0c8c$var$ROLE, "presentation");
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$ROLE, "tab");
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$ARIA_CONTROLS, controls.join(" "));
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$ARIA_LABEL, $2cd9b892908a0c8c$var$format(text, i + 1));
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $2cd9b892908a0c8c$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($2cd9b892908a0c8c$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($2cd9b892908a0c8c$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $2cd9b892908a0c8c$var$focus(item.button);
            go(">" + nextPage);
            $2cd9b892908a0c8c$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $2cd9b892908a0c8c$var$removeClass(button, $2cd9b892908a0c8c$export$72d36ecf3758cb4b);
            $2cd9b892908a0c8c$var$removeAttribute(button, $2cd9b892908a0c8c$var$ARIA_SELECTED);
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $2cd9b892908a0c8c$var$addClass(_button, $2cd9b892908a0c8c$export$72d36ecf3758cb4b);
            $2cd9b892908a0c8c$var$setAttribute(_button, $2cd9b892908a0c8c$var$ARIA_SELECTED, true);
            $2cd9b892908a0c8c$var$setAttribute(_button, $2cd9b892908a0c8c$var$TAB_INDEX, "");
        }
        emit($2cd9b892908a0c8c$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $2cd9b892908a0c8c$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $2cd9b892908a0c8c$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $2cd9b892908a0c8c$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(splide);
        event.on($2cd9b892908a0c8c$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($2cd9b892908a0c8c$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($2cd9b892908a0c8c$export$5adb665701eda1ce, onClick);
        on($2cd9b892908a0c8c$export$6d5af59619d10e6a, onKeydown);
        on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($2cd9b892908a0c8c$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $2cd9b892908a0c8c$var$setAttribute(Components2.Elements.list, $2cd9b892908a0c8c$var$ARIA_ORIENTATION, options.direction === $2cd9b892908a0c8c$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($2cd9b892908a0c8c$var$includes($2cd9b892908a0c8c$var$TRIGGER_KEYS, $2cd9b892908a0c8c$var$normalizeKey(e))) {
            onClick(Slide);
            $2cd9b892908a0c8c$var$prevent(e);
        }
    }
    return {
        setup: $2cd9b892908a0c8c$var$apply(Components2.Media.set, {
            slideFocus: $2cd9b892908a0c8c$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $2cd9b892908a0c8c$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $2cd9b892908a0c8c$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($2cd9b892908a0c8c$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $2cd9b892908a0c8c$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($2cd9b892908a0c8c$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $2cd9b892908a0c8c$var$SR_REMOVAL_DELAY = 90;
function $2cd9b892908a0c8c$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $2cd9b892908a0c8c$var$create("span", $2cd9b892908a0c8c$export$bb78d7c200da8960);
    var interval = $2cd9b892908a0c8c$export$46ad21b25b6dccf0($2cd9b892908a0c8c$var$SR_REMOVAL_DELAY, $2cd9b892908a0c8c$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $2cd9b892908a0c8c$var$setAttribute(track, $2cd9b892908a0c8c$var$ARIA_ATOMIC, true);
            sr.textContent = "…";
            on($2cd9b892908a0c8c$export$23663268a31b79e2, $2cd9b892908a0c8c$var$apply(disable, true));
            on($2cd9b892908a0c8c$export$16a1e4f3d0368265, $2cd9b892908a0c8c$var$apply(disable, false));
            on([
                $2cd9b892908a0c8c$export$fe5802204b967f0d,
                $2cd9b892908a0c8c$export$ff8164bff3202b9
            ], $2cd9b892908a0c8c$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $2cd9b892908a0c8c$var$setAttribute(track, $2cd9b892908a0c8c$var$ARIA_BUSY, active);
        if (active) {
            $2cd9b892908a0c8c$var$append(track, sr);
            interval.start();
        } else {
            $2cd9b892908a0c8c$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $2cd9b892908a0c8c$var$removeAttribute(track, [
            $2cd9b892908a0c8c$var$ARIA_LIVE,
            $2cd9b892908a0c8c$var$ARIA_ATOMIC,
            $2cd9b892908a0c8c$var$ARIA_BUSY
        ]);
        $2cd9b892908a0c8c$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $2cd9b892908a0c8c$var$setAttribute(track, $2cd9b892908a0c8c$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $2cd9b892908a0c8c$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $2cd9b892908a0c8c$var$Media,
    Direction: $2cd9b892908a0c8c$var$Direction,
    Elements: $2cd9b892908a0c8c$var$Elements,
    Slides: $2cd9b892908a0c8c$var$Slides,
    Layout: $2cd9b892908a0c8c$var$Layout,
    Clones: $2cd9b892908a0c8c$var$Clones,
    Move: $2cd9b892908a0c8c$var$Move,
    Controller: $2cd9b892908a0c8c$var$Controller,
    Arrows: $2cd9b892908a0c8c$var$Arrows,
    Autoplay: $2cd9b892908a0c8c$var$Autoplay,
    Cover: $2cd9b892908a0c8c$var$Cover,
    Scroll: $2cd9b892908a0c8c$var$Scroll,
    Drag: $2cd9b892908a0c8c$var$Drag,
    Keyboard: $2cd9b892908a0c8c$var$Keyboard,
    LazyLoad: $2cd9b892908a0c8c$var$LazyLoad,
    Pagination: $2cd9b892908a0c8c$var$Pagination,
    Sync: $2cd9b892908a0c8c$var$Sync,
    Wheel: $2cd9b892908a0c8c$var$Wheel,
    Live: $2cd9b892908a0c8c$var$Live
});
var $2cd9b892908a0c8c$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $2cd9b892908a0c8c$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $2cd9b892908a0c8c$export$ba41d43e4a419565,
    i18n: $2cd9b892908a0c8c$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $2cd9b892908a0c8c$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2).on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $2cd9b892908a0c8c$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $2cd9b892908a0c8c$var$noop
    };
}
function $2cd9b892908a0c8c$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$style, list, "transition");
    var endCallback;
    function mount() {
        $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($2cd9b892908a0c8c$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $2cd9b892908a0c8c$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $2cd9b892908a0c8c$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $2cd9b892908a0c8c$export$7254cc27399e90bd($2cd9b892908a0c8c$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $2cd9b892908a0c8c$var$isString(target) ? $2cd9b892908a0c8c$var$query(document, target) : target;
        $2cd9b892908a0c8c$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $2cd9b892908a0c8c$var$merge({
            label: $2cd9b892908a0c8c$var$getAttribute(root, $2cd9b892908a0c8c$var$ARIA_LABEL) || "",
            labelledby: $2cd9b892908a0c8c$var$getAttribute(root, $2cd9b892908a0c8c$var$ARIA_LABELLEDBY) || ""
        }, $2cd9b892908a0c8c$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $2cd9b892908a0c8c$var$merge(options, JSON.parse($2cd9b892908a0c8c$var$getAttribute(root, $2cd9b892908a0c8c$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $2cd9b892908a0c8c$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($2cd9b892908a0c8c$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $2cd9b892908a0c8c$var$assert(state.is([
            $2cd9b892908a0c8c$var$CREATED,
            $2cd9b892908a0c8c$var$DESTROYED
        ]), "Already mounted!");
        state.set($2cd9b892908a0c8c$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($2cd9b892908a0c8c$export$742b62a5690c060) ? $2cd9b892908a0c8c$var$Fade : $2cd9b892908a0c8c$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $2cd9b892908a0c8c$var$assign({}, $2cd9b892908a0c8c$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $2cd9b892908a0c8c$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $2cd9b892908a0c8c$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($2cd9b892908a0c8c$export$d300dc1a2634364b);
        $2cd9b892908a0c8c$var$addClass(this.root, $2cd9b892908a0c8c$export$7761661e2d5b9388);
        state.set($2cd9b892908a0c8c$var$IDLE);
        this.emit($2cd9b892908a0c8c$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($2cd9b892908a0c8c$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($2cd9b892908a0c8c$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($2cd9b892908a0c8c$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($2cd9b892908a0c8c$var$CREATED)) $2cd9b892908a0c8c$export$f188226459c8a3ff(this).on($2cd9b892908a0c8c$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $2cd9b892908a0c8c$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($2cd9b892908a0c8c$export$88c4cf7419e470cd);
            event.destroy();
            completely && $2cd9b892908a0c8c$var$empty(this.splides);
            state.set($2cd9b892908a0c8c$var$DESTROYED);
        }
        return this;
    };
    $2cd9b892908a0c8c$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $2cd9b892908a0c8c$export$24494c7438c070bf = $2cd9b892908a0c8c$var$_Splide;
$2cd9b892908a0c8c$export$24494c7438c070bf.defaults = {};
$2cd9b892908a0c8c$export$24494c7438c070bf.STATES = $2cd9b892908a0c8c$var$STATES;
var $2cd9b892908a0c8c$var$CLASS_RENDERED = "is-rendered";
var $2cd9b892908a0c8c$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $2cd9b892908a0c8c$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $2cd9b892908a0c8c$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $2cd9b892908a0c8c$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $2cd9b892908a0c8c$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $2cd9b892908a0c8c$var$merge($2cd9b892908a0c8c$export$f484e977a69c6ba6, defaults || {});
        $2cd9b892908a0c8c$var$merge($2cd9b892908a0c8c$var$merge(this.options, $2cd9b892908a0c8c$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $2cd9b892908a0c8c$var$assign({}, $2cd9b892908a0c8c$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $2cd9b892908a0c8c$var$uniqueId("splide");
        this.Style = new $2cd9b892908a0c8c$var$Style(this.id, this.options);
        this.Direction = $2cd9b892908a0c8c$var$Direction(null, null, this.options);
        $2cd9b892908a0c8c$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $2cd9b892908a0c8c$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $2cd9b892908a0c8c$var$queryAll(root, "." + $2cd9b892908a0c8c$export$2c1ba4a4f1aa4947);
        on($2cd9b892908a0c8c$export$d300dc1a2634364b, function() {
            $2cd9b892908a0c8c$var$remove($2cd9b892908a0c8c$var$child(root, "style"));
        });
        $2cd9b892908a0c8c$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $2cd9b892908a0c8c$var$push(this.slides, this.contents.map(function(content, index) {
            content = $2cd9b892908a0c8c$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $2cd9b892908a0c8c$export$72d36ecf3758cb4b : "");
            $2cd9b892908a0c8c$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $2cd9b892908a0c8c$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $2cd9b892908a0c8c$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $2cd9b892908a0c8c$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $2cd9b892908a0c8c$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $2cd9b892908a0c8c$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $2cd9b892908a0c8c$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $2cd9b892908a0c8c$var$unit(padding[prop] || ($2cd9b892908a0c8c$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $2cd9b892908a0c8c$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $2cd9b892908a0c8c$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $2cd9b892908a0c8c$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $2cd9b892908a0c8c$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $2cd9b892908a0c8c$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($2cd9b892908a0c8c$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $2cd9b892908a0c8c$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $2cd9b892908a0c8c$var$merge($2cd9b892908a0c8c$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $2cd9b892908a0c8c$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $2cd9b892908a0c8c$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $2cd9b892908a0c8c$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $2cd9b892908a0c8c$export$93b21159ad85c843,
            $2cd9b892908a0c8c$export$93b21159ad85c843 + "--" + options.type,
            $2cd9b892908a0c8c$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $2cd9b892908a0c8c$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $2cd9b892908a0c8c$export$93b21159ad85c843 + "--nav",
            $2cd9b892908a0c8c$export$72d36ecf3758cb4b,
            !this.config.hidden && $2cd9b892908a0c8c$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $2cd9b892908a0c8c$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $2cd9b892908a0c8c$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $2cd9b892908a0c8c$var$forOwn(styles, function(value, key) {
            style += " " + $2cd9b892908a0c8c$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$2cd9b892908a0c8c$var$push(slides, slides);
        $2cd9b892908a0c8c$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $2cd9b892908a0c8c$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $2cd9b892908a0c8c$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $2cd9b892908a0c8c$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $2cd9b892908a0c8c$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $2cd9b892908a0c8c$var$SIZE + " " + $2cd9b892908a0c8c$var$SIZE + '" width="' + $2cd9b892908a0c8c$var$SIZE + '" height="' + $2cd9b892908a0c8c$var$SIZE + '"><path d="' + (this.options.arrowPath || $2cd9b892908a0c8c$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


function $c74a9c093150ef11$var$maskInputs() {
    document.querySelectorAll("input.phone-mask").forEach((input)=>{
        (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039)(input, {
            mask: "(00) 00000-0000"
        });
    });
    document.querySelectorAll("input.date-mask").forEach((input)=>{
        (0, $7f8f9e4cb1731024$export$2e2bcd8739ae039)(input, {
            mask: Date,
            pattern: "d{/}`m{/}`Y",
            format: (date)=>{
                let day = date.getDate();
                let month = date.getMonth() + 1;
                const year = date.getFullYear();
                if (day < 10) day = "0" + day;
                if (month < 10) month = "0" + month;
                return [
                    day,
                    month,
                    year
                ].join("/");
            },
            parse: (str)=>{
                const yearMonthDay = str.split("/");
                return new Date(yearMonthDay[2], yearMonthDay[1] - 1, yearMonthDay[0]);
            },
            autofix: true,
            max: new Date()
        });
    });
}
function $c74a9c093150ef11$var$setCarousels() {
    new (0, $2cd9b892908a0c8c$export$24494c7438c070bf)(".levels-carousel", {
        type: "slide",
        fixedWidth: "330px",
        gap: "30px",
        padding: "30px",
        focus: "center",
        arrows: false,
        pagination: false,
        mediaQuery: "min",
        breakpoints: {
            1100: {
                drag: false
            }
        }
    }).mount();
    new (0, $2cd9b892908a0c8c$export$24494c7438c070bf)(".reasons-carousel", {
        type: "slide",
        fixedWidth: "260px",
        gap: "30px",
        padding: "30px",
        focus: "center",
        arrows: false,
        pagination: false,
        mediaQuery: "min",
        breakpoints: {
            1100: {
                drag: false
            },
            1400: {
                fixedWidth: false,
                perPage: 5
            }
        }
    }).mount();
}
function $c74a9c093150ef11$var$formSubmit() {
    document.querySelectorAll("form").forEach((form)=>{
        form.addEventListener("submit", function(event) {
            event.preventDefault();
            const whatsappMessage = `Olá, gostaria de receber mais informaçòes.`;
            const whatsappUrl = `https://wa.me/+5511940311105?text=${encodeURIComponent(whatsappMessage)}`;
            fetch("formulario/index.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams(new FormData(form))
            }).then((response)=>response.json()).then((data)=>{
                const messageEl = form.querySelector(".message");
                if (confirm(data.message + "\n\nDeseja tamb\xe9m entrar em contato via WhatsApp?") === true) window.open(whatsappUrl, "_blank");
                if (data.status === "success") {
                    messageEl.classList.remove("error");
                    const url = window.location.protocol + "//" + window.location.host + window.location.pathname + "?g=obrigado";
                    window.location = url;
                } else {
                    messageEl.textContent = data.message;
                    messageEl.classList.add("error");
                }
            }).catch((error)=>{
                console.error("Error:", error);
            });
        });
    });
}
function $c74a9c093150ef11$var$handleThankYou() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get("g");
    if (paramValue === "obrigado") document.querySelectorAll(".message").forEach((element)=>{
        element.classList.add("success");
        element.innerText = "Obrigado por enviar suas informa\xe7\xf5es, em breve entraremos em contato.";
    });
}
$c74a9c093150ef11$var$handleThankYou();
$c74a9c093150ef11$var$setCarousels();
$c74a9c093150ef11$var$formSubmit();
$c74a9c093150ef11$var$maskInputs();


//# sourceMappingURL=index.56d4d85a.js.map
